<template>
  <div class="wrapper">
    <div class="left">
      <div class="header">
        <div class="back">
          <el-button type="text"
                     @click="back">
            <i class="el-icon-arrow-left"></i>
          </el-button>
        </div>
        <div class="title">
          <span class="name">{{plan.Name}} - {{(jobsiteName)}}</span>
          <el-link icon='el-icon-edit'
                   v-has="'Rename Plan'"
                   @click="openRenameDialog"
                   style="font-size:20px;margin:0 15px 0 8px"
                   :title="$t('diagrams.Rename')"
                   :underline="false"></el-link>
        </div>
        <div class="option-line">
          <el-dropdown class="add-task"
                       v-has="'Add Task'"
                       @command="addDragMarker">
            <el-button type="defult"
                       size="mini"
                       style="font-size:14px;color:#3b84dd;border-color:#3b84dd;margin-right:15px;">
              {{$t('model.AddTask')}}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="Task">{{$t('model.Task')}}</el-dropdown-item>
              <el-dropdown-item command="Product">{{$t('model.ProductInstallation')}}</el-dropdown-item>
              <el-dropdown-item command="Moisture">{{$t('model.Moisture')}}</el-dropdown-item>
              <el-dropdown-item v-if="taskTemplates.length > 0"
                                command="TaskTemplate">{{$t('model.TaskTemplate')}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-tooltip class="item"
                      effect="dark"
                      :content="markEditorOptType"
                      placement="bottom">
            <el-button type="text"
                       @click="switchMarkEditor"
                       style="margin-right:50px;width:26px;transition:none"
                       :style="{fontSize:markupEditorIcon.fontSize}">
              <svg-icon v-bind:iconClass="markupEditorIcon.name"></svg-icon>
            </el-button>
          </el-tooltip>

          <el-dropdown @command="handleReportCommand"
                       v-has="'Create Report'">
            <el-button size="mini"
                       type="text"
                       :title="$t('task.NewReport')">
              <svg-icon iconClass="report_add"></svg-icon>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item disabled
                                style="line-height:20px;font-size:12px">Select Report Type</el-dropdown-item>
              <el-dropdown-item :command="composeReportCommand(5)"
                                divided>{{$t('model.Task')}}</el-dropdown-item>
              <el-dropdown-item :command="composeReportCommand(1)">{{$t('model.ProductInstallation')}}</el-dropdown-item>
              <el-dropdown-item :command="composeReportCommand(4)">{{$t('model.Moisture')}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-badge is-dot
                    class="item"
                    :hidden='this.hasCondition'>
            <el-popover placement="bottom-end"
                        width="300"
                        trigger="click">
              <el-button slot="reference"
                         type="text"
                         :title="$t('index.Filters')">
                <svg-icon iconClass="filter"></svg-icon>
              </el-button>
              <el-button size="mini"
                         @click="clearFilter"
                         class="clear">{{$t('model.ClearFilter')}}</el-button>
              <el-form class="filter"
                       size="mini"
                       label-position="top">
                <el-form-item :label="$t('model.Type')">
                  <el-select :placeholder="$t('model.Type')"
                             size="mini"
                             @change="search()"
                             v-model="condition.Type"
                             clearable>
                    <el-option v-for=" i of taskType"
                               :key="i.Key"
                               :label="$t('model.'+i.Value)"
                               :value="i.Key"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('model.Status')">
                  <el-select :placeholder="$t('model.Status')"
                             size="mini"
                             @change="search()"
                             v-model="condition.Status"
                             clearable>
                    <el-option v-for=" i of taskStatus"
                               :key="i.Value"
                               :label="i.Key"
                               :value="i.Value"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('model.TaskGroup')">
                  <el-select size="mini"
                             @change="search()"
                             v-model="condition.GroupId"
                             clearable>
                    <el-option v-for="i of taskGroup"
                               :key="i.PhaseId"
                               :label="i.Name"
                               :value="i.PhaseId"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('model.LocationType')">
                  <el-select clearable
                             @change="search()"
                             v-model="condition.LocationType"
                             size="mini">
                    <el-option :label="$t('model.Floor')"
                               value="1"></el-option>
                    <el-option :label="$t('model.Wall')"
                               value="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('model.DueDate')">
                  <el-row>
                    <el-col :span="11">
                      <el-form-item prop="DueStartTime">
                        <el-date-picker type="date"
                                        :placeholder="$t('model.From')"
                                        @change="search()"
                                        v-model="condition.DueStartTime"
                                        size="mini"
                                        style="width: 100%;"></el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col style="text-align:center"
                            :span="2">-</el-col>
                    <el-col :span="11">
                      <el-form-item prop="DueEndTime">
                        <el-date-picker type="date"
                                        :placeholder="$t('model.To')"
                                        @change="search()"
                                        v-model="condition.DueEndTime"
                                        size="mini"
                                        style="width: 100%;"></el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item :label="$t('model.Assignee')">
                  <el-select :placeholder="$t('model.Assignee')"
                             clearable
                             @change="search()"
                             v-model="condition.AssignedUserIds"
                             size="mini">
                    <el-option v-for="item in projectUser"
                               :key="item.UserId"
                               :label="item.FullName"
                               :value="item.UserId">
                      <div class="user-logo">
                        <img :src="item.AvatarUrl"
                             alt="">
                      </div>
                      <span style="margin-left:40px;">{{ item.FullName }}({{ item.LoginAccount }})</span>
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('model.Watching')">
                  <el-select :placeholder="$t('model.Watching')"
                             clearable
                             @change="search()"
                             v-model="condition.WatchingUserIds"
                             size="mini">
                    <el-option v-for="item in projectUser"
                               :key="item.UserId"
                               :label="item.FullName"
                               :value="item.UserId">
                      <div class="user-logo">
                        <img :src="item.AvatarUrl"
                             alt="">
                      </div>
                      <span style="margin-left:40px;">{{ item.FullName }}({{ item.LoginAccount }})</span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </el-popover>
          </el-badge>
          <el-popover placement="bottom"
                      width="100"
                      v-show="plan.PlanType ===0"
                      trigger="click">
            <el-button type="text"
                       slot="reference"
                       title="View Options">
              <svg-icon iconClass="view options"></svg-icon>
            </el-button>
            <el-checkbox-group v-model="checkView"
                               @change="views()"
                               class="view">
              <el-checkbox :label="i.label"
                           v-for="i in viewSetting"
                           :key="i.label">{{i.name}}</el-checkbox>
            </el-checkbox-group>
          </el-popover>
          <el-tooltip class="item"
                      v-if="this.plan.PlanType ===0"
                      effect="dark"
                      :content="showType"
                      placement="bottom">
            <el-button type="text"
                       @click="on3dRendering()">
              <svg-icon iconClass="products"></svg-icon>
            </el-button>
          </el-tooltip>
          <el-tooltip class="item"
                      effect="dark"
                      :content="$t('model.ZoomAll')"
                      placement="bottom">
            <el-button type="text"
                       @click="resetView">
              <svg-icon iconClass="zoom"></svg-icon>
            </el-button>
          </el-tooltip>
          <el-tooltip class="item"
                      effect="dark"
                      content="Share M2 blueprint"
                      placement="bottom">
            <el-button type="text"
                       icon="el-icon-download"
                       @click="downloadCanvasPdf">
            </el-button>
          </el-tooltip>
        </div>
      </div>
      <div class="main"
           ref="mainDiv">
        <div class="diag">
          <div class="container">
            <div id="canvas"
                 @mouseup.stop="mouseUp"
                 style="height:100%;width: 100%;">
            </div>
            <transition name="fade">
              <div class="toolBar"
                   v-show="isToolBarDisplay">
                <div class="toolBar-container">
                  <div class="toolBarItem"
                       :class="{toolDivActive:toolShows==0}">
                    <el-tooltip content="Pan"
                                placement="right">
                      <button class="toolButton"
                              @click="pan">
                        <div class="Icon">
                          <svg-icon iconClass="markup_hand"
                                    style="width: 22px;height: 22px;"></svg-icon>
                        </div>
                      </button>
                    </el-tooltip>
                  </div>
                  <div class="toolBarItem"
                       :class="{toolDivActive:toolShows==6}">
                    <el-tooltip content="Cloud"
                                placement="right">
                      <button class="toolButton"
                              @click="cloudy">
                        <div class="toolDiv">
                          <i class="toolI"
                             style="filter: drop-shadow(#D3D3D3 22px 0px);">
                            <img src="../../../assets/image/cloud.png">
                          </i>
                        </div>
                      </button>
                    </el-tooltip>
                  </div>
                  <div class="toolBarItem"
                       :class="{toolDivActive:toolShows==1}">
                    <el-tooltip content="Arrow"
                                placement="right">
                      <button class="toolButton"
                              @click="arrow">
                        <div class="toolDiv">
                          <i class="toolI">
                            <img style="height: 17px;"
                                 src="../../../assets/image/arrow.png">
                          </i>
                        </div>
                      </button>
                    </el-tooltip>
                  </div>
                  <div class="toolBarItem"
                       :class="{toolDivActive:toolShows==3}">
                    <el-tooltip content="Free Hand highlight"
                                placement="right">
                      <button class="toolButton"
                              @click="highlight">
                        <div class="toolDiv">
                          <i class="toolI">
                            <img style="height: 20px;"
                                 src="../../../assets/image/highlight.png">
                          </i>
                        </div>
                      </button>
                    </el-tooltip>
                  </div>
                  <div class="toolBarItem"
                       :class="{toolDivActive:toolShows==5}">
                    <el-tooltip content="Free Hand"
                                placement="right">
                      <button class="toolButton"
                              @click="ink">
                        <div class="toolDiv">
                          <i class="toolI">
                            <img style="height: 19px;"
                                 src="../../../assets/image/ink.png">
                          </i>
                        </div>
                      </button>
                    </el-tooltip>
                  </div>
                  <div class="toolBarItem"
                       :class="{toolDivActive:toolShows==8}">
                    <el-tooltip content="Line"
                                placement="right">
                      <button class="toolButton"
                              @click="line">
                        <div class="Icon "
                             style=""><svg xmlns="http://www.w3.org/2000/svg"
                               viewBox="0 0 24 24">
                            <title>icon - tool - shape - line</title>
                            <rect style="fill: #abb0c4;"
                                  x="3"
                                  y="10.75"
                                  width="18"
                                  height="2.5"
                                  rx="0.6"
                                  transform="translate(-4.97 12) rotate(-45)"></rect>
                          </svg></div>
                      </button>
                    </el-tooltip>
                  </div>
                  <div class="toolBarItem"
                       :class="{toolDivActive:toolShows==7}">
                    <el-tooltip content="Ellipse"
                                placement="right">
                      <button class="toolButton"
                              @click="ellipe">
                        <div class="toolDiv">
                          <i style="-webkit-filter: drop-shadow(#D3D3D3 32px 3px);
                                  filter: drop-shadow(#D3D3D3 32px 3px);
                                  left: -32px;"
                             class="toolI">
                            <img style="height: 16px;"
                                 src="../../../assets/image/ellipe.png">
                          </i>
                        </div>
                      </button>
                    </el-tooltip>
                  </div>
                  <div class="toolBarItem"
                       :class="{toolDivActive:toolShows==9}">
                    <el-tooltip content="Rectangle"
                                placement="right">
                      <button class="toolButton"
                              @click="rectangle">
                        <div class="toolDiv">
                          <i style="-webkit-filter: drop-shadow(#C0C0C0 31px 2px);
                                  filter: drop-shadow(#C0C0C0 31px 2px);
                                  left: -31px;"
                             class="toolI">
                            <img style="height: 18px;"
                                 src="../../../assets/image/rectangle.png">
                          </i>
                        </div>
                      </button>
                    </el-tooltip>
                  </div>
                  <div style="margin-top: 4px;">
                    <el-color-picker v-model="toolColor"
                                     :predefine="predefineColors"
                                     @change="changeColor"></el-color-picker>
                  </div>
                  <div class="toolBarItem"
                       style="display:none">
                    <button class="toolButton"
                            style="color:#abb0c4;"
                            @click="setStrokeThickness">
                      {{this.getShowStrokeThickness()}}pt
                    </button>
                    <div style="position: absolute;
                                left: 60px;
                                background-color: #4c4c4c;
                                border-radius: 4px;
                                width: 130px;
                                bottom: 6px;"
                         v-show="isStrokeThickness">
                      <el-slider v-model="strokeThickness"
                                 :min="strokeThicknessInfo.minSize"
                                 :max="strokeThicknessInfo.maxSize"
                                 @change="changeStrokeThickness"></el-slider>
                    </div>
                    <div style="position: absolute;
                                left: 60px;
                                background-color: #4c4c4c;
                                border-radius: 4px;
                                width: 180px;
                                bottom: 6px;"
                         v-show="isFontSize">
                      <el-slider v-model="fontInfo.fontSize"
                                 :min="fontInfo.minSize"
                                 :max="fontInfo.maxSize"
                                 @change="changeStrokeThickness"></el-slider>
                    </div>
                  </div>
                </div>
              </div>
            </transition>

            <el-button size="mini"
                       v-if="conflictTasks.length>0"
                       @click="openTaskConflictDialog"
                       style="right: 10px;position: absolute;top: 10px;z-index:9999;cursor:pointer">
              <img :src="img.replaced"
                   style="width:24px;height:24px;">
            </el-button>

          </div>
        </div>

        <div ref="markupDelete"
             class="Popup AnnotationPopup open react-draggable"
             data-element="annotationPopup"
             v-show="isDeleteIConDisplay"
             @click="deleteMarkup"
             style="left: 653px;top: 878px;transform: translate(0px, 0px);"><button class="Button ActionButton"
                  data-element="annotationDeleteButton"
                  aria-label="Delete"
                  aria-keyshortcuts="Delete"
                  type="button">
            <div class="Icon "><svg xmlns="http://www.w3.org/2000/svg"
                   viewBox="0 0 24 24">
                <!-- <defs>
                  <style>
                  .cls-1 {
                    fill: #abb0c4;
                  }
                  </style>
                </defs> -->
                <title>icon - delete - line</title>
                <path style="fill:currentColor"
                      d="M18,6H17V4a2,2,0,0,0-2-2H9A2,2,0,0,0,7,4V6H3V8H5V20a2,2,0,0,0,2,2H17a2,2,0,0,0,2-2V8h2V6ZM9,4h6V6H9ZM7,20V8H17V20Zm6-10h2v8H13ZM9,10h2v8H9Z"></path>
              </svg></div>
          </button>
        </div>

        <div ref="markerMove"
             class="MarkerMove"
             v-show="isMarkerMoveIConDisplay">
          <div class="MarkerMove Icon">
            <svg-icon iconClass="marker_move"></svg-icon>
          </div>
        </div>

      </div>
    </div>
    <div class="right">
      <el-menu :default-active="onRoute"
               v-if="$route.name !== 'modelTask' && $route.name !== 'roomPanel' && !bathEdit"
               class="el-menu"
               active-text-color="#4193f6"
               @select="select"
               :collapse-transition="false"
               mode="horizontal">
        <el-menu-item index="taskList">
          <svg-icon iconClass="tasks"
                    class="menu-icon"></svg-icon>
          <span slot="title">{{$t('model.Tasks')}}</span>
        </el-menu-item>
        <el-menu-item index="byRoom"
                      v-if="plan.PlanType !==1 && userInfo.RoleType !== 4">
          <svg-icon iconClass="plans"
                    class="menu-icon"></svg-icon>
          <span slot="title">{{$t('model.Rooms')}}</span>
        </el-menu-item>
        <el-menu-item index="byProduct"
                      v-if="plan.PlanType !==1 && userInfo.RoleType !== 4">
          <svg-icon iconClass="products"
                    class="menu-icon"></svg-icon>
          <span slot="title">{{$t('model.Products')}}</span>
        </el-menu-item>
      </el-menu>
      <div class="router-box">
        <router-view></router-view>
      </div>
    </div>
    <add-task-dialog :showDialog="addTaskDialogShow"
                     @closeDialog="closeAddTaskDialog"
                     :type="addTaskType"></add-task-dialog>
    <reportConditionDialog :showDialog="newReportDialog.show"
                           :type="newReportDialog.type"
                           :taskIds="newReportDialog.taskIds"
                           :planId="newReportDialog.planId"
                           @closeDialog="handleNewReportDialog">
    </reportConditionDialog>
    <renameDialog :showDialog="renameDialog.showDialog"
                  :planId="this.plan.PlanId"
                  :planName="this.plan.Name"
                  :showTags="false"
                  @closeDialog="closeRenameDialog">
    </renameDialog>
    <taskConflictDialog :showDialog="taskConflictDialog.showDialog"
                        :conflictTasks="conflictTasks"
                        :conflictRoomAssignments="conflictRoomAssignments"
                        @closeDialog="closeTaskConflictDialog">
    </taskConflictDialog>
  </div>
</template>

<script>
/* eslint-disable */
import { getProtobuf, getProtobufImage, getProductList, getM2MarkupListByPlanId, hasTasksByPlanId, addMarkup, getMarkup, addTask, getTaskById } from '@/api/config'
import { mapState } from 'vuex'
import AddTaskDialog from './addTaskDialog'
import reportConditionDialog from '@/components/report/reportConditionDialog.vue'
import renameDialog from '@components/diagrams/renameDialog.vue'
import taskConflictDialog from '@components/diagrams/taskConflictDialog.vue'
import { Notification } from 'element-ui'
import linearDanger from '@components/diagComponents/img/linear-danger.png'
import linearPrimary from '@components/diagComponents/img/linear-primary.png'
import linearSuccess from '@components/diagComponents/img/linear-success.png'
import moistureDanger from '@components/diagComponents/img/moisture-danger.png'
import moistureNormal_m from '@components/diagComponents/img/moisture-primary.png'
import moistureNormal_i from '@components/diagComponents/img/moisture-drop.png'
import moistureComplete from '@components/diagComponents/img/moisture-success.png'
import productDanger from '@components/diagComponents/img/product-danger.png'
import productComplete from '@components/diagComponents/img/product-success.png'
import productNormal_i from '@components/diagComponents/img/product-warning.png'
import taskDanger from '@components/diagComponents/img/task-danger.png'
import taskComplete from '@components/diagComponents/img/task-success.png'
import taskNormal from '@components/diagComponents/img/task-warning.png'
import taskNormalWall from '@components/diagComponents/img/wall-n.png'
import moistureNormalWall from '@components/diagComponents/img/wall-m-n.png'
import prodectNormalWall from '@components/diagComponents/img/wall-i-n.png'
import wallDanger from '@components/diagComponents/img/wall-danger.png'
import wallComplete from '@components/diagComponents/img/wall-success.png'
import taskSelect from '@components/diagComponents/img/task-select.png'
import replaced from '@components/diagComponents/img/replaced.png'
import selectReplaced from '@components/diagComponents/img/selectReplaced.png'

import jsPDF from 'jspdf'
import { uuid } from 'vue-uuid'
import html2canvas from 'html2canvas'
export default {
  data () {
    return {
      loading: null,
      initPromise: null,
      protobuf: null,
      showType: '3D',
      ErrorPopoverContentVisible: false,
      conflictTasks: [],
      conflictRoomAssignments: [],
      condition: {
        Type: null,
        Status: null,
        GroupId: null,
        DueStartTime: null,
        DueEndTime: null,
        LastUpdatedOn: null,
        AssignedUserIds: null,
        WatchingUserIds: null,
        LocationType: null
      },
      renameDialog: {
        showDialog: false
      },
      taskConflictDialog: {
        showDialog: false
      },
      diag: null,
      markerList: [],
      selectMarker: null,
      movedTaskMarker: null,
      isMarkerMoveIConDisplay: false,
      isMarkerMove: false,
      isMouseDown: false,
      markerOffset: {
        offSetX: -34,
        offSetY: -36
      },
      img: {
        linearDanger: linearDanger,
        linearPrimary: linearPrimary,
        linearSuccess: linearSuccess,
        moistureDanger: moistureDanger,
        moistureDangerWall: wallDanger,
        moistureNormal_m: moistureNormal_m,
        moistureNormal_i: moistureNormal_i,
        moistureNormal_mWall: moistureNormalWall,
        moistureComplete: moistureComplete,
        moistureCompleteWall: wallComplete,
        productDanger: productDanger,
        productDangerWall: wallDanger,
        productComplete: productComplete,
        productCompleteWall: wallComplete,
        productNormal_i: productNormal_i,
        productNormal_iWall: prodectNormalWall,
        taskDanger: taskDanger,
        taskDangerWall: wallDanger,
        taskComplete: taskComplete,
        taskCompleteWall: wallComplete,
        taskNormal: taskNormal,
        taskNormalWall: taskNormalWall,
        taskSelect: taskSelect,
        replaced: replaced,
        selectReplaced: selectReplaced
      },
      checkReportType: 0,
      newReportDialog: {
        show: false,
        type: 1,
        taskIds: [],
        planId: ''
      },
      viewSetting: [
        { label: 'showImage', name: this.$t('model.showImage') },
        { label: 'showWall', name: this.$t('model.Wall') },
        { label: 'showLabel', name: this.$t('model.Label') },
        { label: 'showDimension', name: this.$t('model.Dimension') },
        { label: 'showWallSection', name: this.$t('model.WallSection') },
        { label: 'showAnnotation', name: this.$t('model.Annotation') }
      ],
      checkView: [],
      nonM2ProductList: [],
      isSelectRoom: false,
      isNavigateToTaskList: true,
      markEditorOptType: this.$t('markup.Start'),
      isToolBarDisplay: false,
      isDeleteIConDisplay: false,
      markEditor: null,
      newMarkupData: null, //本地维护的markup数据
      toolShows: 0,
      toolColor: '#F54745',
      predefineColors: ['rgb(245,71,69)', 'rgb(245,145,61)', 'rgb(244,197,66)', 'rgb(82,201,82)', 'rgb(57,118,245)', 'rgb(139,47,190)', 'rgb(160,160,160)', 'rgb(27,27,27)'],
      opacity: 0.5,
      isStrokeThickness: false,
      strokeThickness: 4,
      strokeThicknessInfo: {
        strokeThickness: 4,
        highlightStrokeThickness: 32,
        minSize: 1,
        maxSize: 60
      },
      markupList: [],
      isFontSize: false,
      fontInfo: {
        fontSize: 67,
        minSize: 1,
        maxSize: 128
      },
      toolWidth: {
        line: 2,
        elipse: 2,
        freehand: 2,
        freetext: 68,
        cloudy: 2,
        rectangle: 2,
        highlight: 16,
        arrow: 2
      },
      markupEditorIcon: {
        fontSize: '26px',
        name: 'markup_edit'
      },
      markupVm: null,
      selectedShapes: [],
      actionType: {
        update: 1,
        delete: 2
      },
      iosMarkType: {
        UnKnow: 0,
        Arrow: 1,
        Dimension: 2,
        Text: 3,
        Rectangle: 4,
        Scribble: 5,
        Pin: 6,
        Highlighter: 7,
        Line: 8,
        Oval: 9,
        Polygon: 10,
        Cloud: 11,
        Symbol: 12
      }
    }
  },
  computed: {
    ...mapState(['plan']),
    ...mapState(['jobsiteID', 'jobsiteName', 'userInfo', 'taskStatus', 'taskType', 'taskWorkType', 'temperatureUnit', 'taskGroup', 'projectUser', 'taskTemplates', 'corpId']),
    onRoute () {
      return this.$route.name
    },
    bathEdit () {
      return this.$store.state.diag.data.batchTaskIds.length > 0
    },
    pinList () {
      return this.$store.state.diag.data.pinList
    },
    addRoomList () {
      return this.$store.state.diag.data.addRoomList
    },
    addTaskDialogShow () {
      return this.$store.state.diag.params.addTaskDialog.showDialog
    },
    addTaskType () {
      return parseInt(this.$store.state.diag.params.addTaskDialog.type)
    },
    selectPoint () {
      return this.$store.state.diag.params.selectPoint
    },
    taskShape () {
      return this.$store.state.diag.data.taskShape
    },
    centerPoint () {
      return this.$store.state.diag.data.centerPoint
    },
    roomId () {
      return this.$route.params.roomId
    },
    list () {
      return this.$store.state.diag.data.taskList
    },
    addProductList () {
      return this.$store.state.diag.data.addProductList
    },
    productDialogShow () {
      return this.$store.state.diag.params.productDialog.showDialog
    },
    roomCheck () {
      return this.$store.state.diag.data.roomCheck
    },
    roomList () {
      return this.$store.state.diag.data.roomList
    },
    taskInstallationList () {
      return this.$store.state.diag.data.taskInstallationList
    },
    hasCondition () {
      return (
        (this.condition.Type == null || this.condition.PlanId === '') &&
        (this.condition.Status == null || this.condition.Status === '') &&
        (this.condition.GroupId == null || this.condition.GroupId === '') &&
        (this.condition.DueStartTime == null || this.condition.DueStartTime === '') &&
        (this.condition.DueEndTime == null || this.condition.DueEndTime === '') &&
        (this.condition.LocationType == null || this.condition.LocationType === '') &&
        (this.condition.AssignedUserIds == null || this.condition.AssignedUserIds === '') &&
        (this.condition.WatchingUserIds == null || this.condition.WatchingUserIds === '')
      )
    }
  },
  created () {
    this.$store.commit('diag/resetConiditon', this.condition)
    this.$store.commit('diag/resetConiditon', {
      Name: null,
      OrderBy: 'LastUpdatedOn desc',
      sortValue: 'desc',
      sortBy: 'LastUpdatedOn'
    })
  },
  mounted () {
    this.initPlan()
    this.initJobsiteData()
    this.$store.dispatch('diag/getTasksProgressOptions')
    this.$store.dispatch('getTaskWorkTypes')
    this.$store.dispatch('getTasksStatus')
    this.$store.dispatch('getTasksTypes')
    this.$store.dispatch('getTaskChecklistTemplates')
    this.$store.dispatch('getTaskTemplates')
    window.addEventListener('resize', this.windowResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.windowResize)
  },
  watch: {
    jobsiteID (to, from) {
      if (to) {
        this.initJobsiteData()
      }
    },
    plan (to, from) {
      if (to) {
        this.initPlan()
      }
    },
    roomId (to, from) {
      if (to) {
        this.diag.clearSelection()
        this.highLightShape(to)
        this.getRoom()
      }
    },
    onRoute (to, from) {
      if (to === 'taskList') {
        this.$store.commit('diag/setSelectPoint', {})
        this.$store.commit('diag/clearRoomDetail')
        this.diag.clearSelection()
        this.diag.refresh()
      }
    },
    pinList (to, from) {
      let that = this
      if (!that.diag) {
        that.initPromise.then(() => {
          setTimeout(() => that.addMarker(), 10)
        })
      } else {
        setTimeout(() => that.addMarker(), 10)
      }
    },
    addRoomList (to, from) {
      this.selectRoom()
    },
    addTaskDialogShow (to, from) {
      if (to && this.addRoomList.length > 0) {
        this.getLocationByRoom()
      }
    },
    selectPoint (to, from) {
      if (to.x) {
        if (this.$route.name === 'modelTask') {
          let taskId = this.$route.params.id
          this.movedTaskMarker = this.markerList.find(item => item.TaskId === taskId)
          this.addSelectMarker(to)
        }
      } else if (this.selectMarker) {
        this.diag.removeMarker(this.selectMarker.id)
        this.selectMarker = null
        this.isMarkerMoveIConDisplay = false
      }
    },
    taskShape (to, from) {
      this.diag.clearSelection()
      if (to.length > 0) {
        to.forEach(res => {
          this.highLightShape(res.ShapeId)
        })
      }
    },
    centerPoint (to, from) {
      if (to) {
        if (this.diag) {
          let isView = this.diag.isInView(to)
          if (!isView) {
            this.panCenterTo(to)
          }
        }
      }
    },
    roomCheck (to, from) {
      if (to) {
        this.getProductPoint()
      }
    }
  },
  methods: {
    initPlan () {
      this.clearFilter()
      this.$store.commit('diag/clearRoomDetail')
      this.$store.dispatch('diag/InstallationProductShapes')
      this.initDiagram()
    },
    initJobsiteData () {
      this.getNonM2ProductList()
      this.$store.dispatch('getTaskGroup')
      this.$store.dispatch('getProjectMember')
    },
    getRandomPoint (shapeId) {
      let point = []
      if (this.markerList.length > 0) {
        this.markerList.forEach(ele => {
          point.push(ele.marker.position, point)
        })
      }
      return this.getDiagPointInPolyById(shapeId, point)
    },
    getDiagPointInPolyById (shapeId, excludePoints) {
      let shape = this.getDiagShape(shapeId)
      this.setDiagShapeExtraInfo(shape, false)
      return this.getDiagPointInPoly(shape, excludePoints)
    },
    openTaskConflictDialog () {
      this.taskConflictDialog.showDialog = true
    },
    closeTaskConflictDialog (needRefresh) {
      this.taskConflictDialog.showDialog = false
      if (needRefresh === true) {
        this.$router.push({
          name: 'taskList'
        })
        this.$store.dispatch('diag/getTasksList')
        this.$store.dispatch('diag/InstallationProductShapes')
      }
    },
    openRenameDialog () {
      this.renameDialog.showDialog = true
    },
    closeRenameDialog (val) {
      this.renameDialog.showDialog = false
      if (val.PlanId) {
        this.plan.Name = val.Name
        this.$store.commit('setPlan', this.plan)
      }
    },
    getDiagShapeIds () {
      let roomShapeIds = this.diag.currentLayer.rooms.map(m => m.id)
      if (!roomShapeIds) {
        roomShapeIds = []
      }
      if (this.diag.currentLayer.stairs && this.diag.currentLayer.stairs.length > 0) {
        roomShapeIds = roomShapeIds.concat(this.diag.currentLayer.stairs.map(m => m.id))
      }
      if (this.diag.currentLayer.elevations && this.diag.currentLayer.elevations.length > 0) {
        roomShapeIds = roomShapeIds.concat(this.diag.currentLayer.elevations.map(m => m.id))
      }
      return roomShapeIds
    },
    getProductPoint () {
      let point = []
      if (this.markerList.length > 0) {
        this.markerList.forEach(ele => {
          point.push(ele.marker.position)
        })
      }
      let post = []
      let diagShapeIds = this.getDiagShapeIds()
      for (let i of this.addProductList) {
        let obj = {}
        let intersection = [...i.room].filter(x => diagShapeIds.includes(x.id))
        for (let a of intersection) {
          let list = []
          let assignment = this.diag.getAssignments(a.id)
          for (let b of assignment) {
            for (let c of this.addProductList) {
              if (b.prod.id === c.id) {
                list.push(b)
              }
            }
          }
          a.assignment = list
        }
        obj.room = intersection
        for (let item of obj.room) {
          item.position = this.getDiagPointInPolyById(item.id, point)
        }
        if (intersection.length > 0) {
          if (i.LocationType === 2) {
            for (let j in intersection[0].wallSections) {
              let index = Math.floor(Math.random() * (intersection[0].wallSections.length - 0)) + 0
              let wallPoint = this.getDiagPointInPolyById(intersection[0].wallSections[index].id, point)
              point.push(wallPoint)
              if (wallPoint) {
                obj.point = wallPoint
                break
              }
            }
          } else {
            obj.point = this.getDiagPointInPolyById(intersection[0].id, point)
            point.push(obj.point)
          }
          let assignmentList = []
          for (let item of intersection) {
            let list = this.diag.getAssignments(item.id)
            for (let ele of list) {
              if (ele.prod.id === i.id) {
                ele.roomId = item.id
                ele.TaskAssignType = this.getAssignType(ele)
                assignmentList.push(ele)
              }
            }
          }
          obj.product = assignmentList
          post.push(obj)
        }
      }
      console.log(post)
      this.$store.commit('diag/setProductHandleList', post)
    },
    getShapeTypeName (type) {
      let name = 'unnamed'
      switch (type) {
        case m2dw.ShapeType.ST_ROOM:
          name = 'Room'
          break
        case m2dw.ShapeType.ST_ELEVATION:
          name = 'Elevation'
          break
        case m2dw.ShapeType.ST_STAIRWAY:
          name = 'Stairway'
          break
        case m2dw.ShapeType.ST_TOPELEVATION:
          name = 'Elevation'
          break
        default:
          break;
      }
      return name
    },
    getDiagShape (id) {
      let shape = this.diag.getShape(id)
      return shape
    },
    setDiagShapeExtraInfo (shape, isRoomShow) {
      isRoomShow = isRoomShow || false
      this.setDiagShapeExtraInfoWithoutThis(this, shape)
      if (shape.isStairway) {
        if (isRoomShow) {
          shape.stairway = this.getStairwayInfo(shape)
          //由于可能存在多个stairUnit,diags选中又是整体的,暂时去掉stairUnit的显示
          //shape.stairUnit = this.getStairwayUnit(shape.units)
        }
      }
    },
    setDiagShapeExtraInfoWithoutThis (that, shape) {
      if (!shape) {
        return
      }
      if (!shape.name || shape.name.trim().length == 0) {
        shape.name = that.getShapeTypeName(shape.type)
      }
      shape.isStairway = that.isStairway(shape.type)
      if (shape.isStairway) {
        that.setStairwayFloorWithoutThis(that, shape)
      }
      shape.isElevation = that.isElevation(shape.type)
    },
    isStairway (type) {
      return type === m2dw.ShapeType.ST_STAIRWAY
    },
    isElevation (type) {
      return type === m2dw.ShapeType.ST_ELEVATION || type === m2dw.ShapeType.ST_TOPELEVATION
    },
    getStairwayInfo (stairwayShape) {
      let stairwayProto = stairwayShape.proto
      let leftStringer = stairwayShape.proto.getLeftstringer()
      let rightStinger = stairwayShape.proto.getRightstringer()
      return {
        duplication: stairwayProto.getDuplication(),
        coveringStyle: this.getStairwayCoveringStyle(stairwayProto.getCoveringstyle()),
        extraTopRise: stairwayProto.getHasextratoprise(),
        stepPerBreak: stairwayProto.getStepperbreak(),
        leftStringer: this.getSringerLength(leftStringer),
        rightStringer: this.getSringerLength(rightStinger),
        leftStringerProducts: this.getStringerProducts(leftStringer),
        rightStringerProducts: this.getStringerProducts(rightStinger)
      }
    },
    getStairwayUnit (stairwayUnits) {
      if (!stairwayUnits || stairwayUnits.length == 0) {
        return null
      }
      let stairwayUnitProto = stairwayUnits[0].proto
      return {
        turnsLeft: stairwayUnitProto.getTurnsleft(),
        step: stairwayUnitProto.getStepcount(),
        stairWidth: this.getLengthStr(stairwayUnitProto.getStairwidth()),
        treadWidth: this.getLengthStr(stairwayUnitProto.getTreadwidth()),
        nosing: this.getLengthStr(stairwayUnitProto.getNosing()),
        riseHeight: this.getLengthStr(stairwayUnitProto.getRiseheight()),
        stepThickness: this.getLengthStr(stairwayUnitProto.getStepthickness())
      }
    },
    getSringerLength (stringer) {
      let coordsList = stringer.getCoordsList()
      if (coordsList && coordsList.length >= 4) {
        return this.getLengthStr(this.getDistinceCoods(coordsList))
      }
      return `8'8"`
    },
    getDistinceCoods (coordsList) {
      if (coordsList && coordsList.length >= 4) {
        if (coordsList[0] === coordsList[2]) {
          return Math.abs(this.$config.sub(coordsList[3], coordsList[1]))
        }
        return m2Diag.Point.distanceCoords(coordsList[0], coordsList[1], coordsList[2], coordsList[3])
      }
      return 0
    },
    getLengthStr (qtyNum) {
      return this.getDiagLengthStr(this, qtyNum)
    },
    getDiagLengthStr (that, qtyNum) {
      return that.diag.context.measure.getLen(qtyNum)
    },
    getDiagAreaStr (that, areaNum) {
      return that.diag.measure.getArea(areaNum)
    },
    setRoomAreaLen (that, rooms) {
      if (!rooms || rooms.length === 0) {
        return
      }
      rooms.forEach(ele => {
        ele.len = that.getDiagLengthStr(that, ele.floor.region.perimeter)
        ele.area = that.getDiagAreaStr(that, ele.floor.region.signedArea)
        that.setElevationAreaLen(that, ele.floor.elevations)
      })
    },
    setElevationAreaLen (that, elevations) {
      if (!elevations || elevations.length === 0) {
        return
      }
      for (let elevation of elevations) {
        elevation.len = that.getDiagLengthStr(that, elevation.floor.region.perimeter)
        elevation.area = that.getDiagAreaStr(that, elevation.floor.region.signedArea)
      }
    },
    getStringerProducts (stringer) {
      let results = []
      if (stringer.getLineasgm() && stringer.getLineasgm().getLineasgm()) {
        let stringerProductIndexs = stringer.getLineasgm().getLineasgm().getProductsList()
        if (stringerProductIndexs && stringerProductIndexs.length > 0) {
          let productsList = this.diag.context.model.getProductsList()
          const productsListLength = productsList.length
          for (const stringerProductIndex of stringerProductIndexs) {
            if (stringerProductIndex >= productsListLength) { continue }
            results.push({
              id: productsList[stringerProductIndex].getFepid()
            })
          }
        }
      }
      return results
    },
    getStairwayCoveringStyle (coverStyleNum) {
      let converStyleStr = 'Waterfall'
      switch (coverStyleNum) {
        case m2dw.StairCoveringStyle.SCS_WATERFALL:
          converStyleStr = 'Waterfall'
          break
        case m2dw.StairCoveringStyle.SCS_TREADANDRISE:
          converStyleStr = 'Tread And Rise'
          break
        case m2dw.StairCoveringStyle.SCS_TREADONLY:
          converStyleStr = 'Trad Only'
          break
        case m2dw.StairCoveringStyle.SCS_RISEONLY:
          converStyleStr = 'Rise Only'
          break
        case m2dw.StairCoveringStyle.SCS_FULLWRAP:
          converStyleStr = 'Full Wrap'
          break
        default:
          break
      }
      return converStyleStr
    },
    getDiagPointInPoly (shape, excludePoints) {
      if (shape.isStairway == undefined) {
        this.setDiagShapeExtraInfo(shape, false)
      }
      if (shape.isStairway) {
        return this.getStairwayPointInPoly(shape, excludePoints)
      } else if (shape.isElevation) {
        return this.getElevationPointInPoly(shape, excludePoints)
      }
      return this.diag.getPointInPoly(shape.id, excludePoints)
    },
    setStairwayFloorWithoutThis (that, shape) {
      if (shape.planRegions && shape.planRegions.length > 0) {
        shape.floor = {
          planRegions: that.getStairwayFloorPlanRegions(shape),
          region: that.getStairwayFloorRegionWithoutThis(that, shape)
        }
      }
    },
    getStairwayFloorPlanRegions (shape) {
      return [{ id: shape.id }]
    },
    getStairwayFloorRegionWithoutThis (that, shape) {
      let sumPerimeter = 0
      let sumSignedArea = 0
      for (const planRegion of shape.planRegions) {
        if (planRegion.region) {
          sumPerimeter = that.$config.add(sumPerimeter, planRegion.region.perimeter)
          sumSignedArea = that.$config.add(sumSignedArea, planRegion.region.signedArea)
        }
      }
      return {
        perimeter: sumPerimeter,
        signedArea: sumSignedArea
      }
    },
    getRandomStairUnitIndex (len) {
      return this.$config.getRandomInt(0, len)
    },
    getStairwayPointInPoly (shape, excludePoints) {
      if (shape && shape.proto) {
        let stairwayUnits = shape.proto.getUnitsList()
        if (stairwayUnits && stairwayUnits.length > 0) {
          let index = 0
          if (stairwayUnits.length > 1) {
            index = this.getRandomStairUnitIndex(stairwayUnits.length)
          }
          let poly = stairwayUnits[index].getStairpoly().getPoly()
          let spl = m2Diag.Polygon.get(poly)
          return spl.getRandomPoint(excludePoints)
        }
      }
      return null
    },
    getElevationPointInPoly (elevation, excludePoints) {
      if (elevation && elevation.floor && elevation.floor.region) {
        return elevation.floor.region.getRandomPoint(excludePoints)
      }
      return null
    },
    getRoom () {
      if (this.selectMarker) {
        this.diag.removeMarker(this.selectMarker.id)
        this.selectMarker = null
      }
      let obj = {
        room: this.getDiagShape(this.roomId),
        products: []
      }
      this.setDiagShapeExtraInfo(obj.room, true)
      let products = []
      this.diag.getAssignments(this.roomId).forEach(res => {
        if (this.$config.IsTrackableProduct(res)) {
          res.prod.LocationType = this.getLocationType(res.owner)
          res.prod.TaskAssignType = this.getAssignType(res)
          res.prod.AssignType = res.owner.assignments[0].type
          let index = products.findIndex(q => q.id === res.prod.id && q.TaskAssignType === res.prod.TaskAssignType)
          if (index > -1) {
            products[index].usage += res.usage
            products[index].netArea += res.netArea
          } else {
            res.prod.usage = res.usage
            res.prod.netArea = res.netArea
            products.push(res.prod)
          }
        }
      })
      products.forEach(product => {
        let newAddons = []
        product.addons.forEach(addon => {
          let addonObj = this.diag.products.find(q => q.id === addon.id)
          newAddons.push({ ...addon, unit: addonObj ? addonObj.unit : '' })
        })
        product.newAddons = newAddons
      })
      obj.products = products
      this.$store.commit('diag/setRoomDetail', obj)
    },
    clearFilter () {
      this.condition = {
        Type: null,
        Status: null,
        GroupId: null,
        DueStartTime: null,
        DueEndTime: null,
        LastUpdatedOn: null,
        AssignedUserIds: null,
        WatchingUserIds: null,
        LocationType: null
      }
      this.$store.dispatch('diag/search', this.condition)
    },
    search () {
      this.$store.dispatch('diag/search', this.condition)
    },
    panCenterTo (point) {
      this.diag.panCenterTo(point)
      this.diag.refresh()
    },
    getLocationType (owner) {
      if (this.diag.getParentShape(owner, m2dw.ShapeType.ST_STAIRWAY)) {
        return 1
      }
      if (this.diag.getParentShape(owner, m2dw.ShapeType.ST_WALL) || this.diag.getParentShape(owner, m2dw.ShapeType.ST_DOOR)) {
        return 2
      }
      if (this.diag.getParentShape(owner, m2dw.ShapeType.ST_FLOOR)) {
        return 1
      }
      // const parentShapeType = owner.parentShape.type
      // let locationType = 0
      // switch (parentShapeType) {
      //   case 5:
      //   case 12:
      //     locationType = 2
      //     break;
      //   case 4:
      //   case m2dw.ShapeType.ST_ELEVATION:
      //   case m2dw.ShapeType.ST_STAIRWAY:
      //   case m2dw.ShapeType.ST_TOPELEVATION:
      //     locationType = 1
      //     break
      //   default:
      //     break;
      // }
      // return locationType
    },
    getProdAssignType (assignments) {
      let t = 0
      for (const assignment of assignments) {
        if (this.$config.IsTrackableProduct(assignment)) {
          t = assignment.type
          break
        }
      }
      return t
    },
    getAssignType (assignment) {
      if ((assignment.type === 2 || assignment.prod.type === 'Wall Base') && !this.diag.getParentShape(assignment.owner, m2dw.ShapeType.ST_DOOR)) {
        return 2
      }
      if (this.diag.getParentShape(assignment.owner, m2dw.ShapeType.ST_STAIRWAY)) {
        return 0
      }
      if (this.diag.getParentShape(assignment.owner, m2dw.ShapeType.ST_DOOR)) {
        return 3
      }
      if (this.diag.getParentShape(assignment.owner, m2dw.ShapeType.ST_WALL)) {
        return 1
      }
      //floor
      if (this.diag.getParentShape(assignment.owner, m2dw.ShapeType.ST_FLOOR)) {
        return 0
      }
      return 0
      // let assignType = 0
      // switch (parentShapeType) {
      //   case 12:
      //     assignType = 3
      //     break
      //   case 5:
      //     assignType = 1
      //     break
      //   case 4:
      //   case m2dw.ShapeType.ST_ELEVATION:
      //   case m2dw.ShapeType.ST_STAIRWAY:
      //   case m2dw.ShapeType.ST_TOPELEVATION:
      //     assignType = 0
      //     break
      //   default:
      //     break;
      // }
      // return assignType
    },
    getLocationByRoom () {
      // 房间内获取随机点
      let point = []
      if (this.markerList.length > 0) {
        this.markerList.forEach(ele => {
          point.push(ele.marker.position)
        })
      }
      this.addRoomList.forEach(res => {
        let assignments = this.diag.getAssignments(res.id)
        assignments.forEach(ele => {
          ele.locationType = this.getLocationType(ele.owner)
          ele.TaskAssignType = this.getAssignType(ele)
        })
        let obj = {
          point: this.getDiagPointInPoly(res, point),
          product: assignments,
          room: res
        }
        this.$store.commit('diag/setAddTaskPointList', obj)
      })
    },
    selectRoom () {
      this.diag.clearSelection()
      this.diag.refresh()
      this.addRoomList.forEach(item => {
        this.diag.select(item.id)
      })
    },
    highLightShape (id) {
      this.diag.select(id)
      this.diag.refresh()
    },
    async removeMarker (needRefresh = true) {
      let that = this
      this.markerList.forEach(ele => {
        that.diag.removeMarker(ele.marker.id)
      })
      that.markerList = []
      if (needRefresh) {
        that.diag.refresh()
      }
    },
    addSelectMarker (position) {
      if (this.selectMarker) {
        this.diag.removeMarker(this.selectMarker.id)
      }
      let img = this.img.taskSelect
      for (let i of this.markerList) {
        if (i.replaced && i.marker.position.x === position.x && i.marker.position.y === position.y) {
          img = this.img.selectReplaced
          break
        } else {
          img = this.img.taskSelect
        }
      }
      let marker = this.diag.addMarker(position, img)
      this.selectMarker = marker
      this.diag.refresh()
      let markerMoveICon = this.$refs.markerMove
      this.isMarkerMoveIConDisplay = true
      this.posMarkerMoveICon(-12, -15)
      markerMoveICon.addEventListener('mousedown', this.markerMoveMouseDown)
    },
    markerMoveMouseDown (e) {
      this.bindMainDivEvent()
    },
    pos (event) {
      let posX = 0,
        posY = 0
      let e = event || window.event
      if (e.pageX || e.pageY) {
        posX = e.pageX
        posY = e.pageY
      } else if (e.clientX || e.clientY) {
        posX = event.clientX + document.documentElement.scrollLeft + document.body.scrollLeft
        posY = event.clientY + document.documentElement.scrollTop + document.body.scrollTop
      }
      return { x: posX, y: posY }
    },
    bindMainDivEvent () {
      let mainDiv = this.$refs.mainDiv
      setTimeout(() => {
        mainDiv.addEventListener('mousemove', this.markerMoveMouseMove)
        mainDiv.addEventListener('mouseup', this.markerMoveMouseUp)
      }, 100)
    },
    markerMoveMouseMove (event) {
      this.posSelectMarker(event, this.markerOffset.offSetX, this.markerOffset.offSetY)
    },
    markerMoveMouseUp (event) {
      this.posSelectMarker(event, this.markerOffset.offSetX, this.markerOffset.offSetY)
      this.saveMakerPosition(event)
      this.diag.context.refresh()
      // markerMoveICon.removeEventListener('mousedown', this.markerMoveMouseDown)
      this.removeMainDivEvent()
    },
    saveMakerPosition (event, isOffSet = false) {
      if (this.movedTaskMarker) {
        let pos = this.pos(event)
        if (isOffSet) {
          pos.x = pos.x - 10
          pos.y = pos.y - 10
        }
        let logicalX = this.diag.context.layerView.coord.deviceToLogicalX((pos.x + this.markerOffset.offSetX) * window.devicePixelRatio)
        let logicalY = this.diag.context.layerView.coord.deviceToLogicalY((pos.y + this.markerOffset.offSetY) * window.devicePixelRatio)
        this.updateMarkerPosition(this.movedTaskMarker.TaskId, { x: logicalX, y: logicalY })
      }
    },
    posSelectMarker (event, offSetX, offSetY) {
      let pos = this.pos(event)
      let mainDiv = this.$refs.mainDiv
      let maxWidth = mainDiv.getBoundingClientRect().width
      let maxHeight = mainDiv.getBoundingClientRect().height
      if (pos.x >= maxWidth - 10 || pos.y >= maxHeight - 10) {
        pos.x = pos.x - 10
        pos.y = pos.y - 10
        this.removeMainDivEvent()
        this.saveMakerPosition(event, true)
      }

      let logicalX = this.diag.context.layerView.coord.deviceToLogicalX((pos.x + offSetX) * window.devicePixelRatio)
      let logicalY = this.diag.context.layerView.coord.deviceToLogicalY((pos.y + offSetY) * window.devicePixelRatio)
      this.selectMarker.position.x = logicalX
      this.selectMarker.position.y = logicalY
      if (this.movedTaskMarker) {
        this.movedTaskMarker.marker.position.x = logicalX
        this.movedTaskMarker.marker.position.y = logicalY
      }
      this.posMarkerMoveICon(-12, -15)
      this.diag.context.refresh(true)
    },
    posMarkerMoveICon (offSetX, offSetY) {
      if (!this.selectMarker) return
      let markerMoveICon = this.$refs.markerMove
      let markerPos = this.selectMarker.getDRect(this.diag.context.layerView.coord)
      let posX = (markerPos._x.max + offSetX) / window.devicePixelRatio
      let posY = (markerPos._y.max + offSetY) / window.devicePixelRatio
      let mainDiv = this.$refs.mainDiv
      let maxWidth = mainDiv.getBoundingClientRect().width - 20
      if (posX > maxWidth) {
        this.isMarkerMoveIConDisplay = false
      } else {
        this.isMarkerMoveIConDisplay = true
      }
      markerMoveICon.style.position = 'absolute'
      markerMoveICon.style.left = posX + 'px'
      markerMoveICon.style.top = posY + 'px'
    },
    removeMainDivEvent () {
      let mainDiv = this.$refs.mainDiv
      mainDiv.removeEventListener('mousemove', this.markerMoveMouseMove)
      mainDiv.removeEventListener('mouseup', this.markerMoveMouseUp)
    },
    getSelectMarker (position) {
      return this.markerList.find(item => item.marker.position.x === position.x && item.marker.position.y === position.y)
    },
    saveConflictTasks (conflictTasks, ele, task, assignment, d) {
      let description = Object.assign(d, {
        TaskId: assignment.TaskId,
        SKU: assignment.SKU,
        ShapeId: assignment.ShapeId,
        ShapeName: assignment.ShapeName,
        AssignType: assignment.AssignType,
        IsAreaProduct: assignment.ProductAssignType === 1
      })
      if (!conflictTasks.find(q => q.TaskId === task.TaskId)) {
        conflictTasks.push({
          TaskId: task.TaskId,
          TaskType: ele.taskType,
          Name: task.Name,
          RoomId: task.RoomId,
          Descriptions: [description]
        })
        ele.replaced = true
      } else {
        let conflictTask = conflictTasks.find(q => q.TaskId === task.TaskId)
        if (!conflictTask.Descriptions.find(q => q.SKU === assignment.SKU && q.AssignType === assignment.AssignType)) {
          conflictTask.Descriptions.push(description)
        }
      }
    },
    addMarker () {
      //房间内添加marker
      let that = this
      if (that.selectMarker != null) {
        this.diag.removeMarker(this.selectMarker.id)
      }
      that.removeMarker(false)
      that.conflictTasks = []
      that.roomAssignments = []
      console.log(this.taskInstallationList)
      that.pinList.forEach(ele => {
        // 添加已有task 的 markder
        ele.replaced = false
        if (ele.pin === 'product') {
          for (let i of this.taskInstallationList) {
            //ignore completed task, stair or elevation created by app（roomId will be null, bug）
            if (ele.taskId === i.TaskId && ele.pinColor !== 'Complete' && i.RoomId !== null) {
              if (ele.taskSubtype === 1) {
                if (i.ProductSkus.length > 0) {
                  let hasProduct = that.compareProducts(that.nonM2ProductList, i.ProductSkus)
                  if (!hasProduct) {
                    that.saveConflictTasks(that.conflictTasks, ele, i, {}, { ConflictType: 0 })
                    break
                  }
                }
              } else if (ele.taskType === 4) {
                let roomAssignments = this.diag.getAssignments(i.RoomId)
                if (roomAssignments === null) {
                  let assignment = i.Assignments && i.Assignments.length > 0 ? i.Assignments[0] : { RoomName: 'Room' }
                  that.saveConflictTasks(that.conflictTasks, ele, i, assignment, { ConflictType: 0 })
                  break
                }
                roomAssignments = roomAssignments.filter(q => this.$config.IsTrackableProduct(q))
                roomAssignments.forEach(ele => {
                  ele.locationType = that.getLocationType(ele.owner)
                  ele.TaskAssignType = that.getAssignType(ele)
                })
                if (i.Assignments && i.Assignments.length > 0) {
                  for (let assignment of i.Assignments) {
                    let oldAssignments = roomAssignments.filter(q => q.TaskAssignType === assignment.AssignType && q.prod.id === assignment.SKU)
                    if (oldAssignments.length === 0) {
                      //Product not exist
                      this.saveConflictTasks(that.conflictTasks, ele, i, assignment, { ConflictType: 1 })
                    } else {
                      let totalNetArea = 0
                      for (let oldAssignment of oldAssignments) {
                        totalNetArea += oldAssignment.netArea
                      }
                      let oldTotalNetArea = that.$config.getFormatNumber(assignment.ShapeTotalQty, 2)
                      let newTotalNetArea = that.$config.getFormatNumber(totalNetArea, 2)
                      console.log(oldTotalNetArea + ' ' + newTotalNetArea)
                      if (oldTotalNetArea != newTotalNetArea) {
                        let unit = that.$config.getUnit(oldAssignments[0].prod.unit)
                        let type = that.$config.getProductNum(oldAssignments[0].prod.type)
                        let oldArea = that.$config.transformUnit(oldTotalNetArea, unit, type)
                        let newArea = that.$config.transformUnit(newTotalNetArea, unit, type)
                        that.saveConflictTasks(that.conflictTasks, ele, i, assignment, {
                          ConflictType: 2,
                          OldNetArea: oldArea.num + ' ' + oldArea.text,
                          NewNetArea: newArea.num + ' ' + newArea.text
                        })
                      }
                    }
                  }
                  // OnetoMany from Product tab IgnoreAddConflict will be true
                  if (!i.IgnoreAddConflict) {
                    for (let roomAssignment of roomAssignments) {
                      if (!i.Assignments.some(q => q.AssignType === roomAssignment.TaskAssignType && q.SKU === roomAssignment.prod.id) && !that.conflictTasks.some(q => q.AssignType === roomAssignment.TaskAssignType && q.SKU === roomAssignment.prod.id)) {
                        let sameAPAssignments = roomAssignments.filter(q => q.TaskAssignType === roomAssignment.TaskAssignType && q.prod.id === roomAssignment.prod.id)
                        let totalNetArea = 0
                        for (let a of sameAPAssignments) {
                          totalNetArea += a.netArea
                        }
                        let unit = that.$config.getUnit(roomAssignment.prod.unit)
                        let type = that.$config.getProductNum(roomAssignment.prod.type)
                        let newArea = that.$config.transformUnit(totalNetArea, unit, type)
                        let assignment = {
                          TaskId: that.generateRandomId(),
                          SKU: roomAssignment.prod.id,
                          ShapeId: i.RoomId,
                          ShapeName: i.Assignments[0].ShapeName,
                          ProductAssignType: m2Diag.ProductFactory.getAssignType(roomAssignment.prod.proto),
                          AssignType: roomAssignment.TaskAssignType
                        }
                        that.saveConflictTasks(that.conflictTasks, ele, i, assignment, {
                          ConflictType: 3,
                          NetArea: newArea.num + ' ' + newArea.text
                        })
                      }
                    }
                  }
                  // Invisible Intall Tasks need conflictRoomAssignments
                  if (ele.replaced) {
                    if (that.conflictRoomAssignments.findIndex(q => q.RoomId === i.RoomId) < 0) {
                      let room = that.diag.getShape(i.RoomId)
                      that.conflictRoomAssignments.push({ RoomId: i.RoomId, RoomName: room.name, Assignments: roomAssignments })
                    }
                  }
                }
              }
            }
          }
        }
        let obj = {}
        obj.TaskId = ele.taskId
        let img
        if (ele.replaced) {
          obj.replaced = true
          img = eval('that.img.replaced')
        } else {
          if (ele.position) {
            img = eval('that.img.' + ele.pin + ele.pinColor + ele.position)
          } else {
            img = eval('that.img.' + ele.pin + ele.pinColor)
          }
        }
        let marker = that.diag.addMarker(ele.point, img)
        obj.marker = marker
        that.markerList.push(obj)
      })

      if (that.selectMarker != null) {
        let position = that.selectMarker.position
        let img = null
        for (let i of that.markerList) {
          if (i.marker.position.x === position.x && i.marker.position.y === position.y) {
            if (i.replaced) {
              img = that.img.selectReplaced
            } else {
              img = that.img.taskSelect
            }
            break
          }
        }
        if (img) {
          let marker = that.diag.addMarker(position, img)
          that.selectMarker = marker
        }
        if (that.$route.name === 'modelTask') {
          let taskId = that.$route.params.id
          that.movedTaskMarker = that.markerList.find(item => item.TaskId === taskId)
        }
      }
      that.diag.refresh()
    },
    addDragMarker (command) {
      // 拖拽添加 point
      this.endMarkEditor() //关闭markup编辑
      this.$store.commit('diag/clearAddRoomList')
      let pinName = ''
      let type
      if (command === 'Task') {
        pinName = 'taskNormal'
        type = 0
      }
      if (command === 'Product') {
        pinName = 'productNormal_i'
        type = 1
      }
      if (command === 'Moisture') {
        pinName = 'moistureNormal_m'
        type = 2
      }
      if (command === 'TaskTemplate') {
        pinName = 'taskNormal'
        type = 3
      }
      let that = this
      if (that.selectMarker) {
        that.diag.removeMarker(that.selectMarker.id)
        that.selectMarker = null
      }
      let markerState = new m2Diag.MoveAddMarkerState(that.diag, eval('that.img.' + pinName))
      that.diag.state = markerState
      markerState.onMarkerAdded = marker => {
        let point = marker.position
        let obj = {
          product: null,
          room: null,
          point: point
        }
        if (that.plan.PlanType === 0) {
          let room = that.getDiagParentShapeWithoutThis(that, marker.parentShape)
          that.setDiagShapeExtraInfoWithoutThis(that, room)
          if (room) {
            obj.room = room
            if ((command === 'Product' || command === 'TaskTemplate') && room) {
              let product = that.diag.getAssignments(room.id)
              product.forEach(ele => {
                ele.locationType = that.getLocationType(ele.owner)
                ele.TaskAssignType = that.getAssignType(ele)
              })
              obj.product = product
            }
          }
          if ((!obj.product || obj.product.length === 0) && command === 'Product') {
            that.$message.error(that.$t('model.ThereIsNoProduct'))
            that.diag.removeMarker(marker.id)
            that.selectShape()
            return
          }
        }
        that.$store.commit('diag/setAddTaskPointList', obj)
        that.$store.commit('diag/setAddTaskType', type)
        that.$store.commit('diag/openAddTaskDialog', true)
        let objM = {
          TaskId: '',
          marker: marker
        }
        that.markerList.push(objM)
      }
      markerState.onMarkerCanceled = () => {
        that.selectShape()
      }
    },
    getDiagParentShapeWithoutThis (that, shape) {
      if (shape) {
        if (shape._type === m2dw.ShapeType.ST_PLANREGION) {
          return that.getDiagPlanRegionParentShapeWithoutThis(that, shape)
        } else if (shape._type === m2dw.ShapeType.ST_STAIRWAY) {
          return shape
        }
      }
      return null
    },
    getDiagPlanRegionParentShapeWithoutThis (that, shape) {
      let selectShape = that.diag.getParentShape(shape, m2dw.ShapeType.ST_ELEVATION)
      if (!selectShape) {
        selectShape = that.diag.getParentShape(shape, m2dw.ShapeType.ST_ROOM)
        if (!selectShape) {
          selectShape = that.diag.getParentShape(shape, m2dw.ShapeType.ST_TOPELEVATION)
        }
      }
      return selectShape
    },
    getDiagStairwayParentShapeWithoutThis (that, shape) {
      return that.diag.getParentShape(shape, m2dw.ShapeType.ST_STAIRWAY)
    },
    selectShape () {
      let that = this
      that.diag.state.onSelectShape = (event, shape, point) => {
        if (shape) {
          if (shape._type === 1020) {
            // 点击pin 跳转任务
            that.markerList.find(item => {
              if (item.marker.id === shape.id) {
                that.$router.push({
                  name: 'modelTask',
                  params: {
                    id: item.TaskId
                  }
                })
              }
            })
          }
          else if (shape._type === 1001) {
            if (that.showType === '2D' && that.isSelectRoom == false) {
              that.diag.viewSetting.showImage = false
              that.diag.resetView()
            }
            that.isSelectRoom = true
            this.$store.commit('diag/setSelectPoint', {})
            let selectShape = that.getDiagParentShapeWithoutThis(that, shape)
            if (!selectShape) {
              return
            }
            that.$router.push({
              name: 'roomPanel',
              params: {
                roomId: selectShape.id
              }
            })
            that.isMarkerMoveIConDisplay = false
          }
          else if (shape._type === m2dw.ShapeType.ST_STAIRWAY) {
            if (that.showType === '2D' && that.isSelectRoom == false) {
              that.diag.viewSetting.showImage = false
              that.diag.resetView()
            }
            that.isSelectRoom = true
            this.$store.commit('diag/setSelectPoint', {})
            //this.highLightShape(shape.id)//?
            that.$router.push({
              name: 'roomPanel',
              params: {
                roomId: shape.id
              }
            })
            that.isMarkerMoveIConDisplay = false
          }
        } else if (!shape && this.onRoute !== 'taskList' && this.onRoute !== 'byRoom' && this.onRoute !== 'byProduct') {
          that.isSelectRoom = false
          this.$router.push({
            name: 'taskList'
          })

          that.isMarkerMoveIConDisplay = false
        }
      }
    },
    async updateMarkerPosition (taskId, point) {
      let updateTask
      await getTaskById(taskId).then(res => {
        updateTask = res
      })
      if (updateTask) {
        updateTask.LocationX = point.x
        updateTask.LocationY = point.y
      }
      addTask([updateTask], true).then(res => {
        console.log('res', ...res)
      })
    },
    removeMouseMove () {
      // this.diag.state.onMouseMove = (event, shape, point) => {
      // }
      // this.diag.state.onMouseUp = (event, shape, point) => {
      // }
    },
    initDiagram () {
      this.loading = this.$loading({
        lock: true,
        text: this.$t('welcome.Loading'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      let that = this
      that.initPromise = new Promise(function (resolve, reject) {
        getProtobuf(that.plan.PlanId)
          .then(async res => {
            if (res) {
              that.protobuf = res
              await that.init()
            }
            that.onDataLoaded()
            if (res && that.roomId) {
              that.getRoom()
              that.highLightShape(that.roomId)
            }
            that.loading.close()
            resolve()
          })
          .catch(e => {
            that.loading.close()
            reject()
          })
      })
    },
    async init () {
      //初始化
      let that = this
      let options = {
        panZoom: true,
        imageZIndex: 1,
        support3d: true,
        viewSetting: {
          showMarkerAsTop: true,
          showImage: true,
          showWall: false,
          showLabel: true,
          showDimension: true,
          showWallSection: true,
          showAnnotation: true
        }
      }
      for (let i in options.viewSetting) {
        if (options.viewSetting[i]) {
          this.checkView.push(i)
        }
      }
      options.onImageLoading = (filePath, imgEle) => {
        return that.onProtobufImageLoading(filePath, imgEle)
      }
      return new Promise(function (resolve, reject) {
        if (that.diag === null) {
          that.diag = new m2Diag.Engine('canvas', options)
        }
        that.diag.state.on3dRendering = () => {
          that.loading = that.$loading({
            target: '.main .diag',
            lock: true,
            text: that.$t('welcome.Loading'),
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
        }
        that.diag.state.on3dRendered = () => {
          that.loading.close()
        }
        that.diag.state.onDataLoaded = () => resolve()
        that.diag.loadData(that.protobuf)
        that.diag.state.onZoom = event => {
          if (that.selectMarker) {
            that.posMarkerMoveICon(-12, -15)
          }
        }
        that.diag.state.onMouseDown = (event, shape, point) => {
          that.isMouseDown = true
        }
        that.diag.state.onMouseMove = (event, shape, point) => {
          if (that.isMouseDown && that.isMarkerMoveIConDisplay) {
            that.posMarkerMoveICon(-12, -15)
          }
        }
        that.diag.state.onMouseUp = (event, shape, point) => {
          that.isMouseDown = false
        }
        //that.initMarkEditor()
      })
    },
    getPlanProtobufImage (path) {
      return new Promise((resolve, reject) => {
        getProtobufImage(this.plan.PlanId, path)
          .then(res => {
            let blob = new Blob([res], {
              type: res.type
            })
            resolve(blob)
          })
          .catch(err => { })
      })
    },
    async onProtobufImageLoading (filePath, imgEle) {
      let imgBlob = await this.getPlanProtobufImage(filePath)
      let objectUrl = URL.createObjectURL(imgBlob)
      imgEle.src = objectUrl
    },
    onDataLoaded () {
      let that = this
      that.diag.viewSetting.onlySelectionIn3d = true
      that.diag.resetView()
      that.setRoomAreaLen(that, that.diag.currentLayer.rooms)
      that.setElevationAreaLen(that, that.diag.currentLayer.elevations)
      that.$store.commit('diag/setRoomList', that.diag.currentLayer.rooms) // 保存 房间列表
      let product = []
      let assignmentList = that.diag.getAssignments(that.diag.currentLayer.id)
      for (let res of assignmentList) {
        if (this.$config.IsTrackableProduct(res)) {
          if (that.getLocationType(res.owner)) {
            res.prod.LocationType = that.getLocationType(res.owner)
          } else {
            res.prod.LocationType = 1
          }
          res.prod.TaskAssignType = that.getAssignType(res)
          res.prod.room = []
          res.prod.usage = 0
          product.push(res.prod)
        }
      }
      product = that.$config.arrUnique(product, 'id')
      let productList = []
      for (let i of product) {
        for (let j of assignmentList) {
          if (i.id === j.prod.id) {
            let room = that.getDiagPlanRegionParentShapeWithoutThis(that, j.owner)
            if (!room) {
              room = that.getDiagStairwayParentShapeWithoutThis(that, j.owner)
            }
            if (room) {
              that.setDiagShapeExtraInfoWithoutThis(that, room)
              i.room.push(room)
            }
            i.usage += j.usage
          }
        }
        let newAddons = []
        i.addons.forEach(addon => {
          let addonObj = this.diag.products.find(q => q.id === addon.id)
          newAddons.push({ ...addon, unit: addonObj ? addonObj.unit : '' })
        })
        i.newAddons = newAddons
        productList.push(i)
      }
      for (let i of productList) {
        i.room = this.$config.arrUnique(i.room, 'id')
      }
      that.$store.dispatch('diag/postProduct', productList)
      that.selectShape()
      if (this.plan.PlanType === 0 || this.plan.PlanType === 1) {
        // getM2MarkupListByPlanId(this.plan.PlanId).then(res => {
        //   if (res) {
        //     let isAdd = false
        //     if (res.Markups && res.Markups instanceof Array && res.Markups.length > 0) {
        //       for (let item of res.Markups) {
        //         that.diag.addMarkup(item)
        //         isAdd = true
        //       }
        //     }
        //     if (res.Highlighter && res.Highlighter instanceof Array && res.Highlighter.length > 0) {
        //       for (let highlightItem of res.Highlighter) {
        //         highlightItem.IsEndsRound = true//todo
        //         that.diag.addHighlighter(highlightItem)
        //         isAdd = true
        //       }
        //     }
        //     if (res.Note && res.Note instanceof Array && res.Note.length > 0) {
        //       for (let noteItem of res.Note) {
        //         const pos = new m2Diag.Point(noteItem.pos.x, noteItem.pos.y)
        //         that.diag.addNote(pos, noteItem.text, noteItem.options)
        //         isAdd = true
        //       }
        //     }
        //     if (isAdd) {
        //       that.diag.refresh()
        //     }
        //   }
        // })
        this.initMarkEditor()
      }
    },
    zoom (type) {
      if (type) {
        this.diag.zoom(true)
      } else {
        this.diag.zoom(false)
      }
    },
    views () {
      this.diag.viewSetting.showWall = false
      this.diag.viewSetting.showLabel = false
      this.diag.viewSetting.showDimension = false
      this.diag.viewSetting.showWallSection = false
      this.diag.viewSetting.showAnnotation = false
      this.diag.viewSetting.showImage = false
      for (let i of this.checkView) {
        switch (i) {
          case 'showWall':
            this.diag.viewSetting.showWall = true
            break
          case 'showLabel':
            this.diag.viewSetting.showLabel = true
            break
          case 'showDimension':
            this.diag.viewSetting.showDimension = true
            break
          case 'showWallSection':
            this.diag.viewSetting.showWallSection = true
            break
          case 'showAnnotation':
            this.diag.viewSetting.showAnnotation = true
            break
          case 'showImage':
            this.diag.viewSetting.showImage = true
        }
      }
      this.diag.refresh()
    },
    resetView () {
      this.diag.resetView()
      if (this.markEditor) {
        this.markEditor.stageSelector.update()
        this.markEditor.update(true)
      }
      if (this.isMarkerMoveIConDisplay) {
        this.posMarkerMoveICon(-12, -15)
      }
    },
    downloadCanvasPdf () {
      this.diag.resetView()
      setTimeout(() => {
        let canvasDiv = document.querySelector('.diag #canvas')
        html2canvas(canvasDiv, {
          width: canvasDiv.clientWidth,
          height: canvasDiv.clientHeight,
          useCORS: true
        }).then(c => {
          let context = c.getContext('2d')
          context.mozImageSmoothingEnabled = false
          context.webkitImageSmoothingEnabled = false
          context.msImageSmoothingEnabled = false
          context.imageSmoothingEnabled = false
          let img = c.toDataURL('image/png')
          let pdf = new jsPDF('l', 'pt', 'a4')
          pdf.text(10, 20, this.plan.Name + ' - ' + this.jobsiteName)

          let pdfWidth = pdf.internal.pageSize.getWidth()
          let pdfHeight = pdf.internal.pageSize.getHeight()
          let pageWidth = pdfWidth - 20
          let pageHeight = pdfHeight - 20
          let widthRatio = pageWidth / c.width
          let heightRatio = pageHeight / c.height
          let ratio = widthRatio > heightRatio ? heightRatio : widthRatio
          let canvasWidth = c.width * ratio
          let canvasHeight = c.height * ratio
          let marginX = (pdfWidth - canvasWidth) / 2
          let marginY = (pdfHeight - canvasHeight) / 2
          pdf.addImage(img, 'PNG', marginX, 20 + marginY, canvasWidth, canvasHeight)

          pdf.save(this.plan.Name + '-' + this.jobsiteName + '.pdf')
        })
      }, 100)
    },
    on3dRendering () {
      if (this.showType === '3D') {
        if (this.isSelectRoom) {
          this.diag.viewSetting.showImage = false
        } else {
          this.diag.viewSetting.showImage = this.checkView.indexOf('showImage') !== -1
        }
        this.diag.resetView()
        this.showType = '2D'
      } else {
        this.diag.viewSetting.showImage = this.checkView.indexOf('showImage') !== -1
        this.showType = '3D'
      }
      this.diag.context.switch2d3d()
    },
    select (index, indexPath) {
      this.$router.push({
        name: index
      })
      this.$store.commit('diag/setAddRoomList', [])
    },
    back () {
      this.$store.commit('diag/clearTaskList')
      this.$store.commit('diag/clearTaskSortby')
      this.$store.commit('diag/setProtobuf')
      this.$router.push({
        name: 'diagrams',
        params: {
          projectId: this.jobsiteID
        },
        query: {
          r: 1
        }
      })
    },
    async closeAddTaskDialog (id) {
      this.selectShape()
      this.$store.commit('diag/openAddTaskDialog', false)
      this.$store.commit('diag/clearAddTaskPointList')
      this.$store.dispatch('getTaskGroup')
      if (id) {
        if (typeof id === 'string') {
          this.$router.push({
            name: 'modelTask',
            params: {
              id: id
            }
          })
        } else {
          if (this.$router.currentRoute.name !== 'taskList') {
            this.$router.push({
              name: 'taskList'
            })
          }
        }
        this.$store.dispatch('diag/getTasksList')
        await this.getNonM2ProductList()
      } else {
        let addDragMarker = this.markerList.pop()
        this.diag.removeMarker(addDragMarker.marker.id)
        this.diag.clearSelection()
        this.diag.refresh()
      }
      this.reloadMarkupToDiag()
    },
    composeReportCommand (type) {
      return {
        type: type
      }
    },
    async handleReportCommand (commmand) {
      let pinType = ''
      let msgType = ''
      let taskType = 0
      switch (commmand.type) {
        case 5:
          pinType = 'task'
          msgType = this.$t('model.Task')
          taskType = 0
          break
        case 1:
          pinType = 'product'
          msgType = this.$t('model.ProductInstallation')
          taskType = 1
          break
        case 4:
          pinType = 'moisture'
          msgType = this.$t('model.Moisture')
          taskType = 2
          break
      }
      let hasTask = await this.hasTasksByPlanId(taskType)
      if (hasTask === true) {
        this.openNewReport(commmand.type)
      } else {
        Notification.closeAll()
        Notification({
          title: this.$t('api.WARNING'),
          message: this.$t('model.PleaseCreate', [msgType]),
          duration: 3000,
          showClose: false,
          customClass: 'customNotify'
        })
      }
    },
    openNewReport (type) {
      this.newReportDialog.show = true
      this.newReportDialog.type = type
      this.newReportDialog.planId = this.plan.PlanId
    },
    handleNewReportDialog () {
      this.newReportDialog.show = false
      this.newReportDialog.type = 1
      this.newReportDialog.planId = null
    },
    getNonM2ProductList () {
      let that = this
      let nonM2ProductCondition = {
        SKU: null,
        JobsiteId: that.jobsiteID,
        PageIndex: 1,
        PageSize: 10000,
        GetRecycle: false,
        OrderBy: 'LastUpdatedOn desc'
      }
      getProductList(nonM2ProductCondition).then(res => {
        that.nonM2ProductList = res.Data
      })
    },
    compareProducts (p1, p2) {
      for (let a of p2) {
        if (!p1.find(y => y.SKU === a)) {
          return false
        }
      }
      return true
    },
    async hasTasksByPlanId (taskType) {
      let hasTask = false
      await hasTasksByPlanId(this.plan.PlanId, taskType).then(res => {
        hasTask = res
      })
      return hasTask
    },
    async initMarkEditor () {
      if (this.diag != null) {
        let res = await this.loadXfdMarkups()
        this.newMarkupData = res
        this.addMarkup(res)
      }
    },
    switchMarkEditor () {
      if (this.markEditor == null) {
        this.startMarkEditor()
      } else {
        this.endMarkEditor()
      }
    },
    startMarkEditor () {
      this.toolShows = 0
      this.isToolBarDisplay = true
      this.markEditorOptType = this.$t('markup.Done')
      this.markupEditorIcon.fontSize = '22px'
      this.markupEditorIcon.name = 'markup_save'
      if (this.markEditor == null) {
        this.markEditor = new m2DiagExtends.Client.MarkEditor(this.diag.context)
      }
      if (!this.diag) {
        this.markEditor = undefined
        return
      }
      this.initMarkupWeakMap()
      if (this.newMarkupData) {
        if ((this.newMarkupData.highlighters != undefined && this.newMarkupData.highlighters.length > 0) || (this.newMarkupData.markups != undefined && this.newMarkupData.markups.length > 0)) {
          this.shiftToEditor()
          this.markEditor.update(true)
          this.clearMarkup()
        }
      }
      this.bindEditorEndDraw()
      this.bindEditorEvent()
    },
    resize () {
      this.diag.context.resize()
      this.diag.context.refresh(true)
      this.markEditor.resize()
      this.markEditor.stageSelector.update()
      this.markEditor.update(true)
    },
    clearMarkup () {
      if (!this.diag) return
      if (this.markupList.length == 0) return
      let that = this
      this.markupList.forEach(mk => {
        that.diag.context.removeCustomShape(mk.id)
      })
      this.markupList.splice(0)
      this.diag.refresh()
    },
    shiftToEditor () {
      if (!this.markEditor) return
      let helper = new m2DiagExtends.Client.MarkEditorHelper(this.markEditor, this.diag.context)
      const highlighters = this.newMarkupData.highlighters.map(hl => this.convertHighlighterToEditor(hl, helper))
      const markups = this.newMarkupData.markups.map(mu => this.convertMarkupToEditor(mu, helper))
      this.markEditor.stage.addShapes([...highlighters, ...markups])
    },
    convertHighlighterToEditor (highlighterOption, helper) {
      if (!this.markEditor) return
      let hl = new m2Diag.Highlighter(highlighterOption)
      let highlighterShape = helper.convertHighlighterToEditor(hl)
      this.setMarkupWeakMap(highlighterShape, highlighterOption.id)
      return highlighterShape
    },
    convertMarkupToEditor (markupOption, helper) {
      if (!this.markEditor) return
      let mu = new m2Diag.Markup(markupOption)
      let markupShape = helper.convertMarkupToEditor(mu)
      this.setMarkupWeakMap(markupShape, markupOption.id)
      return markupShape
    },
    initMarkupWeakMap () {
      if (!this.markupVm) {
        this.markupVm = new WeakMap()
      }
    },
    clearMarkupWeakMap () {
      if (this.markupVm) {
        this.markupVm = null
      }
    },
    setMarkupWeakMap (markup, id) {
      this.markupVm.set(markup, id)
    },
    endMarkEditor () {
      this.toolShows = 0
      this.isToolBarDisplay = false
      this.markEditorOptType = this.$t('markup.Start')
      this.markupEditorIcon.fontSize = '26px'
      this.markupEditorIcon.name = 'markup_edit'
      if (this.markEditor) {
        this.markEditor.free()
        this.markEditor = undefined
        this.reloadMarkupToDiag() // 结束时只需要重绘markup到diag即可
      }
      this.clearMarkupWeakMap()
      this.hideDeleteICon()
    },
    getMarkEditorConfig () {
      let markConfig = {
        color: this.hexToRgb(this.toolColor),
        opacity: this.opacity,
        thickness: this.getMarkupThickness()
      }
      return markConfig
    },
    getMarkupThickness () {
      let width = 4
      switch (this.toolShows) {
        case 1:
        case 8:
          width = this.toolWidth.line
          break
        case 3:
          width = this.toolWidth.highlight
          break
        case 4:
          width = this.toolWidth.freetext
          break
        case 5:
          width = this.toolWidth.freehand
          break
        case 6:
          width = this.toolWidth.cloudy
          break
        case 7:
          width = this.toolWidth.elipse
          break
        case 9:
          width = this.toolWidth.rectangle
          break
        default:
          break
      }
      return width
    },
    getDefaultThickness (m2MarkType) {
      switch (m2MarkType) {
        case 0:
          return this.toolWidth.line
        case 1:
          return this.toolWidth.arrow
        case 2:
          return this.toolWidth.elipse
        case 3:
          return this.toolWidth.rectangle
        case 4:
          return this.toolWidth.cloudy
        default:
          return this.toolWidth.highlight
      }
    },

    setMarkEditorStyle (markType) {
      if (!this.markEditor) return
      this.markEditor.markConfig = this.getMarkEditorConfig()
      this.markEditor.startDrawMark(markType)
      this.clearSelectShapes()
    },
    pan () {
      this.toolShows = 0
      this.clearSelectShapes()
    },
    cloudy () {
      this.toolShows = 6
      this.setMarkEditorStyle(m2DiagExtends.Client.MarkType.MU_CLOUD)
    },
    arrow () {
      this.toolShows = 1
      this.setMarkEditorStyle(m2DiagExtends.Client.MarkType.MU_ARROW)
    },
    highlight () {
      this.toolShows = 3
      this.setMarkEditorStyle(m2DiagExtends.Client.MarkType.HL_PLOYGON)
    },
    ink () {
      this.toolShows = 5
      this.setMarkEditorStyle(m2DiagExtends.Client.MarkType.MU_LINES)
    },
    line () {
      this.toolShows = 8
      this.setMarkEditorStyle(m2DiagExtends.Client.MarkType.MU_LINE)
    },
    ellipe () {
      this.toolShows = 7
      this.setMarkEditorStyle(m2DiagExtends.Client.MarkType.MU_OVAL)
    },
    rectangle () {
      this.toolShows = 9
      this.setMarkEditorStyle(m2DiagExtends.Client.MarkType.MU_RECT)
    },
    addMarkup (markupData) {
      if (!this.diag) return
      if (markupData) {
        let that = this
        if (markupData.markups != undefined && markupData.markups.length > 0) {
          markupData.markups.forEach(mu => {
            let muRes = that.diag.addMarkup(mu)
            if (!mu.id) {
              muRes.id = this.generateRandomId()
            } else {
              muRes.id = mu.id
            }
            that.markupList.push(muRes)
          })
        }
        if (markupData.highlighters != undefined && markupData.highlighters.length > 0) {
          markupData.highlighters.forEach(hl => {
            let hlRes = that.diag.addHighlighter(hl)
            if (!hl.id) {
              hlRes.id = this.generateRandomId()
            } else {
              hlRes.id = hl.id
            }
            that.markupList.push(hlRes)
          })
        }
        if (markupData.notes != undefined && markupData.notes.length > 0) {
          markupData.notes.forEach(note => {
            const pos = new m2Diag.Point(note.pos.x, note.pos.y)
            that.diag.addNote(pos, note.text, note.options)
          })
        }
        this.diag.context.viewSetting.showMarkup = true
        this.diag.refresh()
      }
    },
    reloadMarkupToDiag () {
      this.addMarkup(this.newMarkupData) // 重绘markup到diag中
    },
    changeColor () {
      this.changeMarkupColor()
    },
    activeChangeColor (color) {
      //可以做到选中颜色就切换颜色
      let hexColor = this.rgbToHex(color)
      this.toolColor = hexColor
      this.changeMarkupColor()
    },
    clearSelectShapes () {
      if (this.selectedShapes.length > 0) {
        this.selectedShapes.splice(0)
      }
    },
    changeMarkupColor () {
      if (this.selectedShapes.length > 0) {
        for (let index = 0; index < this.selectedShapes.length; index++) {
          let opacity = this.getOpacity(this.selectedShapes[index].style.stroke)
          let newColor = this.hexToRgbaStr(this.toolColor, opacity)
          this.selectedShapes[index].style.stroke = newColor
        }
        this.markEditor.stageSelector.update()
        this.markEditor.update()
        this.markEditor.endDrawMark()
      }
      this.updateManyMarkup(this.selectedShapes, this.actionType.update)
      //this.selectedShapes.splice(0)
    },
    setStrokeThickness () { },
    getShowStrokeThickness () { },
    changeStrokeThickness () { },
    hexToRgbaStr (hex, opacity) {
      let colors = this.hexToRgb(hex)
      if (opacity != undefined) {
        return `rgba(${colors[0]},${colors[1]},${colors[2]},${opacity})`
      } else {
        return `rgba(${colors[0]},${colors[1]},${colors[2]},1)`
      }
    },
    getOpacity (rgba) {
      if (!/^(rgba|RGBA)/.test(rgba)) {
        return 1
      }
      let colors = rgba.toString().match(/\d+(?:\.\d+)?/g)
      return Number(colors[colors.length - 1])
    },
    hexToRgb (hex) {
      let colors = [0, 0, 0]
      let reg = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/
      if (reg.test(hex)) {
        var hex = hex.slice(1)
        if (hex.length === 3) {
          for (let i = 0; i < 3; i++) {
            colors[i] = parseInt(hex[i] + hex[i], 16)
          }
        } else if (hex.length === 6) {
          for (let i = 0; i < 3; i++) {
            colors[i] = parseInt('0x' + hex.substr(i * 2, 2))
          }
        }
      }
      return colors
    },

    rgbToHex (rgb) {
      if (!/^(rgb|RGB)/.test(rgb)) {
        return rgb
      }
      let color = rgb.toString().match(/\d+/g)
      let hex = '#'
      for (let i = 0; i < 3; i++) {
        if (color[i] < 0 || color[i] > 255) {
          return rgb
        }
        hex += ('0' + Number(color[i]).toString(16)).slice(-2)
      }
      return hex
    },
    convertUintNumberToColor (number) {
      const alpha = (number >> 24) & 0xff
      const red = (number >> 16) & 0xff
      const green = (number >> 8) & 0xff
      const blue = number & 0xff
      let color = [red, green, blue]
      let hex = '#'
      for (let i = 0; i < 3; i++) {
        hex += ('0' + Number(color[i]).toString(16)).slice(-2)
      }
      return hex
    },
    convertColorToUintNumber (hexColor, alpha) {
      if (!hexColor.includes('#')) {
        return hexColor
      }
      let colors = this.hexToRgb(hexColor) // [r,g,b]
      const a = alpha ? Math.round(alpha * 0xff) : 0xff
      let res = (colors[0] << 16) | (colors[1] << 8) | colors[2] | (a << 24)
      return res >>> 0
    },
    getDrawMarkType (markupOptions) {
      let markType = undefined
      let helper = new m2DiagExtends.Client.MarkEditorHelper(this.markEditor, this.diag.context)
      if (markupOptions.markupType != undefined) {
        let markup = new m2Diag.Markup(markupOptions)
        markType = helper.getMarkupMarkType(markup)
      } else {
        let highlighter = new m2Diag.Highlighter(markupOptions)
        markType = helper.getHighlighterMarkType(highlighter)
      }
      console.log('markType', markType)
      return markType
    },
    getIOSMarkupType (drawMarkupType) {
      switch (drawMarkupType) {
        case m2DiagExtends.Client.MarkType.MU_LINE:
          return this.iosMarkType.Line //
        case m2DiagExtends.Client.MarkType.MU_PLOYGON:
          return this.iosMarkType.Polygon
        case m2DiagExtends.Client.MarkType.MU_OVAL:
          return this.iosMarkType.Oval
        case m2DiagExtends.Client.MarkType.HL_PLOYGON:
          return this.iosMarkType.Highlighter
        case m2DiagExtends.Client.MarkType.MU_LINES:
          return this.iosMarkType.Line //
        case m2DiagExtends.Client.MarkType.MU_CLOUD:
          return this.iosMarkType.Cloud
        case m2DiagExtends.Client.MarkType.MU_ARROW:
          return this.iosMarkType.Arrow
      }
    },
    saveMarkupData (that, markupId, markupType, isDeleted, xmlString) {
      let data = [
        {
          MarkupId: markupId,
          CorpId: that.corpId,
          JobsiteId: that.jobsiteID,
          PlanId: that.plan.PlanId,
          TaskId: '',
          MarkupType: markupType,
          Shape: xmlString,
          MarkupCategory: 1,
          IsDeleted: isDeleted
        }
      ]
      addMarkup(data).then(res => {
        console.log('res', ...res)
      })
    },
    saveManyMarkupData (data) {
      addMarkup(data).then(res => {
        console.log('res', ...res)
      })
    },
    generateRandomId () {
      return uuid.v4()
    },
    loadXmlStr (xmlStr) {
      let xmlDoc = null
      if (window.DOMParser) {
        let parse = new DOMParser()
        xmlDoc = parse.parseFromString(xmlStr, 'text/xml')
      } else {
        if (window.ActiveXObject) {
          xmlDoc = new ActiveXObject('Microsoft.XMLDOM')
          xmlDoc.async = false
          xmlDoc.loadXML(xmlDoc)
        }
      }
      return xmlDoc
    },
    parserXMLToString (xmlDOM) {
      if (window.ActiveXObject) {
        return xmlDOM.xml
      } else if (document.implementation && document.implementation.createDocument) {
        return new XMLSerializer().serializeToString(xmlDOM)
      }
    },
    convertShapeToMarkupOptions (shape) {
      let markupId = this.markupVm.get(shape)
      let helper = new m2DiagExtends.Client.MarkEditorHelper(this.markEditor, this.diag.context)
      if (!markupId) {
        markupId = this.generateRandomId()
      }
      let markupOptions = helper.convertToMU(shape)
      if (!markupOptions) {
        markupOptions = helper.convertToHL(shape)
      }
      if (markupOptions) {
        markupOptions.id = markupId
        return markupOptions
      }
      return null
    },
    addMarkupOptions (markupOptions) {
      if (!this.newMarkupData) return
      if (markupOptions.markupType != undefined) {
        this.newMarkupData.markups.push(markupOptions)
      } else {
        this.newMarkupData.highlighters.push(markupOptions)
      }
    },
    removeMarkupOptions (markupOptions) {
      if (!this.newMarkupData) return
      if (markupOptions.markupType != undefined) {
        let index = this.newMarkupData.markups.findIndex(mk => mk.id === markupOptions.id)
        this.newMarkupData.markups.splice(index, 1)
      } else {
        let index = this.newMarkupData.highlighters.findIndex(mk => mk.id === markupOptions.id)
        this.newMarkupData.highlighters.splice(index, 1)
      }
    },
    replaceMarkupOptions (markupOptions) {
      if (!this.newMarkupData) return
      if (markupOptions.markupType != undefined) {
        let index = this.newMarkupData.markups.findIndex(mk => mk.id === markupOptions.id)
        this.newMarkupData.markups.splice(index, 1, markupOptions)
      } else {
        let index = this.newMarkupData.highlighters.findIndex(mk => mk.id === markupOptions.id)
        this.newMarkupData.highlighters.splice(index, 1, markupOptions)
      }
    },
    updateManyMarkup (shapes, actionType) {
      if (shapes.length == 0) return
      let data = []
      for (const shape of shapes) {
        let markupOptions = this.convertShapeToMarkupOptions(shape)
        let iosMarkType = this.getIOSMarkupType(drawMarkupType)
        let drawMarkupType = this.getDrawMarkType(markupOptions)
        if (markupOptions) {
          let xmlStr = this.getXfdfString(this, drawMarkupType, markupOptions)
          data.push({
            MarkupId: markupOptions.id,
            CorpId: this.corpId,
            JobsiteId: this.jobsiteID,
            PlanId: this.plan.PlanId,
            TaskId: '',
            MarkupType: iosMarkType,
            Shape: xmlStr,
            MarkupCategory: 1,
            IsDeleted: actionType === this.actionType.update ? false : true
          })
        }
        if (actionType === this.actionType.delete) {
          this.removeMarkupOptions(markupOptions)
          this.markupVm.delete(shape)
        } else {
          this.replaceMarkupOptions(markupOptions)
        }
      }
      if (data.length > 0) {
        this.saveManyMarkupData(data)
      }
    },
    bindEditorEndDraw () {
      if (!this.markEditor) return
      this.markEditor.endDrawMarked = endType => {
        this.pan()
        this.isDeleteIConDisplay = false
      }
    },
    bindEditorEvent () {
      if (!this.markEditor) return
      let that = this
      const event = new m2DiagExtends.Client.MarkEditorEvent()
      event.onCreateShaped = (event, shapes) => {
        if (shapes.length == 0) return
        let markupOptions = that.convertShapeToMarkupOptions(shapes[0])
        let drawMarkupType = that.getDrawMarkType(markupOptions)
        let iosMarkupType = that.getIOSMarkupType(drawMarkupType)
        if (markupOptions) {
          let iosXml = that.getXfdfString(that, drawMarkupType, markupOptions)
          console.log(iosXml)
          that.saveMarkupData(that, markupOptions.id, iosMarkupType, false, iosXml)
          that.addMarkupOptions(markupOptions)
          that.markupVm.set(shapes[0], markupOptions.id)
        }
        that.markEditor.endDrawMark()
        that.markEditor.stageSelector.clearSelected()
        that.markEditor.stage.update()
        that.markEditor.update(true)
      }
      event.onDeleteShaped = (event, shapes) => {
        that.updateManyMarkup(shapes, that.actionType.delete)
        that.hideDeleteICon()
      }
      event.onModifyShaped = (event, shapes, type) => {
        that.updateManyMarkup(shapes, that.actionType.update)
      }
      event.onSelectShaped = (event, shapes) => {
        if (shapes.length > 0) {
          that.selectedShapes = [...shapes]
        }
      }
      event.onClickOutShaped = event => {
        that.hideDeleteICon()
      }
      event.onStageUpdated = event => {
        if (that.isDeleteIConDisplay && that.selectedShapes.length == 1) {
          that.posDeleteICon(-20, 15)
        }
      }

      this.markEditor.addEvent(event)
    },
    async getMarkups (pageIndex, pageCount) {
      let condition = {
        JobsiteId: this.jobsiteID,
        PlanId: this.plan.PlanId,
        TaskId: '',
        GetRecycle: false,
        LastUpdatedOn: '',
        PageIndex: pageIndex,
        PageSize: pageCount
      }
      return await getMarkup(condition)
    },
    generateXfdfStrings (resData) {
      let len = resData.length
      let array = []
      for (let index = 0; index < len; index++) {
        array.push(resData[index].Shape)
      }
      return array.join('')
    },
    getM2MarkupType (markupElement) {
      if (markupElement.tagName === 'FepTopHighlighter') {
        return undefined
      } else {
        let markupType = markupElement.getAttribute('markupType')
        if (markupType != undefined) {
          switch (markupType) {
            case 'Polygon':
              return 3
            case 'Oval':
              return 2
            case 'Cloud':
              return 4
            case 'Arrow':
              return 1
          }
        } else {
          return 0 //line and lines
        }
      }
    },
    async loadXfdMarkups () {
      let pageIndex = 1
      let pageSize = 100
      let markupData = {
        markups: [],
        highlighters: [],
        notes: []
      }
      let res = await this.getMarkups(pageIndex, pageSize)
      if (res.Data && res.Data.length > 0) {
        const xmlTemplate = '<?xml version="1.0" encoding="utf-8"?>\
                          <xfdf xmlns="http://ns.adobe.com/xfdf/" xml:space="preserve">\
                          <markups>\
                          </markups>\
                          </xfdf>'
        let xmlDoc = this.loadXmlStr(xmlTemplate)
        if (xmlDoc) {
          let markups = xmlDoc.getElementsByTagName('markups')
          if (markups && markups.length > 0) {
            markups[0].innerHTML = this.generateXfdfStrings(res.Data)
            const len = markups[0].children.length
            if (len > 0 && res.Data.length == len) {
              for (let index = 0; index < len; index++) {
                const childEle = markups[0].children[index]
                if (childEle.tagName != 'FepTopHighlighter' && childEle.tagName != 'FepTopMarkup' && childEle.tagName != 'FepTopNote') {
                  continue
                }
                if (childEle.tagName === 'FepTopNote') {
                  let posArr = childEle.getAttribute('labelPos').split(',').map(Number)
                  let showArrow = childEle.getAttribute('arrowVisible') == 'true'
                  let borderStyle = Number(childEle.getAttribute('borderStyle'))
                  let lineColor = Number(childEle.getAttribute('lineColor'))
                  let bgColor = Number(childEle.getAttribute('background'))
                  let note = childEle.getAttribute('label')
                  let modelFont = childEle.getElementsByTagName('ModelFont')[0]
                  let family = ''
                  let size = 0
                  let color = ''
                  if (modelFont) {
                    family = modelFont.getAttribute('name')
                    size = Number(modelFont.getAttribute('size'))
                    color = Number(modelFont.getAttribute('color'))
                  }
                  markupData.notes.push({
                    pos: { x: posArr[0], y: posArr[1] },
                    text: note,
                    options: {
                      color: color,
                      size: size,
                      family: family,
                      bgColor: bgColor,
                      lineColor: lineColor,
                      borderStyle: borderStyle,
                      showArrow: showArrow,
                      arrowPosition: null
                    }
                  })
                } else {
                  let m2MarkType = this.getM2MarkupType(childEle)
                  let color = childEle.getAttribute('color')
                  let uintColor = Number(color)
                  let thickness = this.getDefaultThickness(m2MarkType)
                  if (childEle.getAttribute('thickness')) {
                    thickness = Number(childEle.getAttribute('thickness'))
                  }
                  let pointStr = childEle.getAttribute('points')
                  let points = this.getPointsFromXml(pointStr)
                  if (m2MarkType != undefined) {
                    //markup
                    let markup = {
                      thickness: thickness,
                      color: uintColor,
                      markupType: m2MarkType,
                      points: points,
                      id: res.Data[index].MarkupId
                    }
                    markupData.markups.push(markup)
                  } else {
                    //highlighter
                    let isClosed = false //default
                    let isEndsRound = true //default
                    if (childEle.getAttribute('IsClosed') != undefined) {
                      isClosed = childEle.getAttribute('IsClosed') === 'true'
                    }
                    if (childEle.getAttribute('IsEndsRound') != undefined) {
                      isEndsRound = childEle.getAttribute('IsEndsRound') === 'true'
                    }
                    markupData.highlighters.push({
                      thickness: thickness,
                      color: uintColor,
                      points: points,
                      IsClosed: isClosed,
                      IsEndsRound: isEndsRound,
                      id: res.Data[index].MarkupId
                    })
                  }
                }
              }
            }
          }
        }
      }
      return markupData
    },
    getXfdfString (that, drawMarkupType, markup) {
      let xmldoc = null
      let element = null
      let pointsStr = that.getPointsStr(markup.points)
      let shapeId = that.getShapeId()
      switch (drawMarkupType) {
        case 0: //HL_RECT
          break
        case 1: //HL_FREEDRAW
          break
        case 2: //HL_PLOYGON
          xmldoc = that.loadXmlStr('<FepTopHighlighter   endsCap="Round"  />')
          element = xmldoc.children[0]
          element.setAttribute('color', markup.color)
          element.setAttribute('thickness', markup.thickness)
          element.setAttribute('IsClosed', markup.IsClosed)
          element.setAttribute('IsEndsRound', markup.IsEndsRound)
          element.setAttribute('shapeId', shapeId)
          element.setAttribute('points', pointsStr)
          break
        case 3: //HL_PLOYGON_BUTT
          break
        case 4: //HL_LINE
          break
        case 5: //HL_LINE_BUTT
          break
        case 6: //MU_RECT
          break
        case 7: //MU_OVAL
          xmldoc = that.loadXmlStr('<FepTopMarkup   markupType="Oval"  />')
          element = xmldoc.children[0]
          element.setAttribute('color', markup.color)
          element.setAttribute('shapeId', shapeId)
          element.setAttribute('points', pointsStr) //MT_OVAL
          break
        case 8: //MU_CLOUD
          xmldoc = that.loadXmlStr('<FepTopMarkup  markupType="Cloud"  />')
          element = xmldoc.children[0]
          element.setAttribute('color', markup.color)
          element.setAttribute('shapeId', shapeId)
          element.setAttribute('points', pointsStr)
          break
        case 9: //MU_PLOYGON
          xmldoc = that.loadXmlStr('<FepTopMarkup   markupType="Polygon"  />')
          element = xmldoc.children[0]
          element.setAttribute('color', markup.color)
          element.setAttribute('shapeId', shapeId)
          element.setAttribute('points', pointsStr)
          break
        case 10: //MU_LINE
          xmldoc = that.loadXmlStr('<FepTopMarkup  />')
          element = xmldoc.children[0]
          element.setAttribute('color', markup.color)
          element.setAttribute('shapeId', shapeId)
          element.setAttribute('points', pointsStr)
          break
        case 11: //MU_ARROW
          xmldoc = that.loadXmlStr('<FepTopMarkup   markupType="Arrow"  />')
          element = xmldoc.children[0]
          element.setAttribute('color', markup.color)
          element.setAttribute('shapeId', shapeId)
          element.setAttribute('points', pointsStr)
          break
        case 12: //MU_LINES
          xmldoc = that.loadXmlStr('<FepTopMarkup    />')
          element = xmldoc.children[0]
          element.setAttribute('color', markup.color)
          element.setAttribute('shapeId', shapeId)
          element.setAttribute('points', pointsStr)
          break
        default:
          break
      }
      let result = ''
      if (xmldoc) {
        result = that.parserXMLToString(xmldoc)
      }
      return result
    },
    getPointsStr (points) {
      if (points.length === 0) {
        return ''
      }
      let pointArr = []
      for (let i = 0; i < points.length; i += 2) {
        pointArr.push(points.slice(i, i + 2).join(','))
      }
      return pointArr.join('|')
    },
    getPointsFromXml (pointStr) {
      let str = pointStr.replaceAll('|', ',')
      return str.split(',').map(Number)
    },
    getShapeId () {
      var s = []
      var hexDigits = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWSYZ'
      for (var i = 0; i < 8; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * hexDigits.length), 1)
      }
      var shapeId = s.join('')
      return shapeId
    },
    mouseUp (e) {
      e.preventDefault()
      if (this.selectedShapes.length == 1) {
        this.isDeleteIConDisplay = true
        this.posDeleteICon(-20, 15)
      }
    },
    windowResize () {
      if (this.diag && this.markEditor) {
        this.resize()
      }
      if (this.isDeleteIConDisplay && this.selectedShapes.length == 1) {
        this.posDeleteICon(-20, 15)
      }
      if (this.isMarkerMoveIConDisplay) {
        this.diag.context.resize()
        this.diag.context.refresh(true)
        this.posMarkerMoveICon(-12, -15)
      }
    },
    debounce (fn, delay) {
      let time = null
      let timer = null
      let newTime = null
      function task () {
        newTime = +new Date()
        if (newTime - time < delay) {
          timer = setTimeout(task, delay)
        } else {
          fn()
          timer = null
        }
        time = newTime
      }
      return function () {
        // 更新时间戳
        time = +new Date()
        if (!timer) {
          timer = setTimeout(task, delay)
        }
      }
    },
    posDeleteICon (offSetX, offSetY) {
      let posX = 0,
        posY = 0
      let deleteICon = this.$refs.markupDelete
      let selectBBox = this.markEditor.getShapeBBox(this.selectedShapes[0])
      posY = selectBBox.min.y / window.devicePixelRatio
      posX = (selectBBox.min.x + (selectBBox.max.x - selectBBox.min.x) / 2) / window.devicePixelRatio
      deleteICon.style.position = 'absolute'
      deleteICon.style.top = posY + offSetY + 'px'
      deleteICon.style.left = posX + offSetX + 'px'
    },
    deleteMarkup () {
      if (this.selectedShapes.length == 1) {
        let selectShape = this.selectedShapes[0]
        this.markEditor.stageSelector.clearSelected(0)
        this.markEditor.stageSelector.update()
        let index = this.markEditor.stage.shapes.indexOf(selectShape)
        this.markEditor.stage.removeShapes([index])
        this.markEditor.stage.update()
        this.markEditor.update(true)
        this.updateManyMarkup(this.selectedShapes, this.actionType.delete)
        this.hideDeleteICon()
      }
    },
    hideDeleteICon () {
      this.isDeleteIConDisplay = false
      this.clearSelectShapes()
    }
  },
  components: {
    AddTaskDialog,
    reportConditionDialog,
    renameDialog,
    taskConflictDialog
  }
}
</script>
<style lang="scss" scoped>
.toolBar {
  z-index: 100;
  left: 20px;
  top: 50%;
  position: fixed;
  margin-top: -225px;
  cursor: grab;
  .toolBar-container {
    border-radius: 3px;
    display: flex;
    flex-direction: column;
    background-color: #4c4c4c;
    width: auto;
    padding: 0.25rem;
    .toolBarItem {
      height: 40px;
      background-color: #686363;
      margin-top: 4px;
      border-radius: 30px;
      .toolDiv {
        display: inline-block;
        width: 22px;
        height: 22px;
        overflow: hidden;
        .toolI {
          position: relative;
          left: -22px;
          filter: drop-shadow(#abb0c4 22px 0px);
          img {
            height: 22px;
          }
        }
      }
    }
  }
}

.toolButton {
  padding: 0;
  border: none;
  background-color: transparent;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 4px;
  width: 40px;
  height: 40px;
}
.toolDivActive {
  button {
    border: 2px solid white;
    border-radius: 30px;
    filter: brightness(100);
  }
}

.toolButton:hover {
  border: 2px solid white;
  border-radius: 30px;
  filter: brightness(100);
}

.Icon {
  width: 22px;
  height: 22px;
  pointer-events: none;
  color: #868e96;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.open.AnnotationPopup {
  visibility: visible;
}

.closed.AnnotationPopup {
  visibility: hidden;
}

@media (min-width: 901px) {
  .hide-in-desktop {
    display: none;
  }
}

@media (min-width: 641px) and (max-width: 900px) {
  .App:not(.is-in-desktop-only-mode) .hide-in-tablet {
    display: none;
  }
}

@media (max-width: 640px) and (min-width: 431px) {
  .hide-in-mobile {
    display: none;
  }
}

@media (max-width: 430px) {
  .hide-in-small-mobile {
    display: none;
  }
}

.always-hide {
  display: none;
}

.AnnotationPopup {
  position: absolute;
  z-index: 110;
  display: flex;
  justify-content: center;
  align-items: center;
}

.AnnotationPopup:empty {
  padding: 0;
}

.AnnotationPopup .buttons {
  display: flex;
}

.AnnotationPopup .Button {
  margin: 4px;
  width: 32px;
  height: 32px;
}

@media (max-width: 640px) {
  .App:not(.is-in-desktop-only-mode) .AnnotationPopup .Button {
    width: 42px;
    height: 42px;
  }
}

.AnnotationPopup .Button:hover {
  background: #e7edf3;
}

.AnnotationPopup .Button .Icon {
  width: 18px;
  height: 18px;
}

@media (max-width: 640px) {
  .App:not(.is-in-desktop-only-mode) .AnnotationPopup .Button .Icon {
    width: 24px;
    height: 24px;
  }
}

@-webkit-keyframes bottom-up {
  0% {
    transform: translateY(100%);
  }

  to {
    transform: translateY(0);
  }
}

@keyframes bottom-up {
  0% {
    transform: translateY(100%);
  }

  to {
    transform: translateY(0);
  }
}

@-webkit-keyframes up-bottom {
  0% {
    transform: translateY(0);
  }

  to {
    transform: translateY(100%);
  }
}

@keyframes up-bottom {
  0% {
    transform: translateY(0);
  }

  to {
    transform: translateY(100%);
  }
}

.AnnotationPopup {
  border-radius: 4px;
  box-shadow: 0 0 3px 0 #868e96;
  background: #fff;
}

.shortCuts3D {
  position: relative;
}

.shortCuts3D .closeButton {
  position: absolute;
  right: 4px;
  padding: 2px;
  cursor: pointer;
  width: 20px;
  text-align: center;
}

.shortCuts3D .row {
  padding: 4px 0;
  margin: 8px 26px 8px 16px;
}

.shortCuts3D .row span {
  background: #e7ebee;
  padding: 4px 8px;
  border-radius: 4px;
}

.Button {
  padding: 0;
  border: none;
  background-color: transparent;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 4px;
  width: 32px;
  height: 32px;
  color: #485056;
}

html:not([data-tabbing="true"]) .Button {
  outline: none;
}

.MarkerMove {
  z-index: 110;
  cursor: move;
}

.MarkerMove .Icon {
  width: 44px;
  height: 30px;
  pointer-events: none;
  color: #1296db;
  display: flex;
  justify-content: center;
  align-content: center;
}

.MarkerMove .Icon svg {
  width: 28px;
  height: 28px;
}

@media screen and(-webkit-min-device-pixel-ratio:2) {
  // .MarkerMove .Icon {
  //   width: 44px;
  //   height: 30px;
  //   pointer-events: none;
  //   color: #1296db;
  //   display: flex;
  //   justify-content: center;
  //   align-content: center;
  // }

  .MarkerMove .Icon svg {
    width: 18px;
    height: 18px;
  }
}
</style>

<style lang="scss">
.view {
  width: 100%;
  .el-checkbox {
    display: block !important;
    width: 100%;
    height: 30px;
    line-height: 30px;
    .el-checkbox__input {
      display: none;
    }
    &.is-checked {
      position: relative;
      &:after {
        content: "";
        display: block;
        height: 20px;
        width: 20px;
        background-image: url("../../../assets/image/check.png");
        color: #4193f6;
        background-size: 100%;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
  .el-radio {
    display: block !important;
    width: 100%;
    height: 30px;
    line-height: 30px;
    .el-radio__input {
      display: none;
    }
    &.is-checked {
      position: relative;
      &:after {
        content: "";
        display: block;
        height: 20px;
        width: 20px;
        background-image: url("../../../assets/image/check.png");
        color: #4193f6;
        background-size: 100%;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
}
.clear {
  position: absolute;
  right: 5px;
  top: 5px;
}
.customNotify {
  .el-notification__content {
    text-align: left;
  }
}

.el-color-dropdown__main-wrapper {
  display: none;
}
.el-color-dropdown {
  background-color: #686363;
}
.el-color-dropdown__btns {
  .el-color-dropdown__value {
    display: none;
  }
  .el-color-dropdown__link-btn {
    display: none;
  }
  // .el-color-dropdown__btn {
  //   //  display: none;
  // }
}
</style>
<style scoped lang='scss'>
.wrapper {
  position: relative;
  width: 100%;
  flex-direction: row;
  .left {
    height: 100%;
    flex-grow: 1;
    .header {
      height: 38px;
      overflow: hidden;
      padding: 0 8px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #dcdfe6;
      justify-content: space-between;
      .el-button {
        font-size: 20px;
      }
      .title {
        display: flex;
        flex: 1;
        width: 0;
        .name {
          padding-left: 8px;
          font-size: 20px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .option-line {
        max-width: 500px;
        z-index: 1000;
        display: flex;
        align-items: center;
        margin-left: 24px;
        /deep/.el-button {
          margin-right: 8px;
          margin-left: 8px;
          font-size: 24px;
        }
      }
    }
    .main {
      height: calc(100% - 38px);
      .diag {
        width: 100%;
        height: 100%;
        position: relative;
        .add-task {
          position: absolute;
          right: 20px;
          top: 10px;
          z-index: 1000;
        }
        .container {
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
          z-index: 15;
          canvas {
            z-index: 10;
            width: 100%;
            height: 100%;
            position: absolute;
            // left: 50%;
            // top: 50%;
            // transform: translate(-50%, -50%);
          }
        }
      }
    }
  }
  .right {
    width: 450px;
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    border-left: 1px solid #dcdfe6;
    .router-box {
      flex-grow: 2;
      height: 0;
    }
    .el-menu {
      display: flex;
      li {
        flex-grow: 1;
        padding: 0;
        text-align: center;
        height: 39px;
        line-height: 38px;
        font-size: 16px;
        .menu-icon {
          margin-right: 10px;
        }
      }
    }
  }
}
.user-logo {
  width: 30px;
  height: 30px;
  overflow: hidden;
  border-radius: 50%;
  position: absolute;
  left: 20px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  img {
    width: 30px;
    height: 30px;
  }
}
/deep/.el-badge__content.is-fixed.is-dot {
  bottom: 6px;
  top: auto;
  right: 21px;
}
</style>


